<template>
  <div class="content">
    <div  class="folder-control-wrap">
      <div  class="frm-row height-38" >
        <!-- <div ref="currentPathDiv" v-show="this.show.currentPath" class="frm-item grow left folder-path-wrap"
        style="height: 38px; width : 1050px; overflow: hidden;"> -->
        <div  ref="currentPathDiv" v-show="this.show.currentPath" class="frm-item grow left folder-path-wrap "
        style="overflow: hidden;">
          <div v-if="searchKeywordFlag || searchFilterFlag || inCompleteFilterFlag" class="current-path">
            <!-- No4:スキャナ保存対応「ファイル一覧_電子取引・スキャナ保存_フォルダ表示」画面で検索欄の文言変更(対象は「すべてのフォルダ」の場合) -->
            <span v-if="searchedTarget == '0'" class="current-path-align">検索場所：電子取引・スキャナ保存</span>
            <span v-if="searchedTarget != '0'">
              <span class="current-path-align">検索場所：</span>
              <span ref="currentPathRyaku" class="current-path-align">≪&emsp;</span>
              <span name="currentPathSpanName" v-for="value, index in currentFolderKeyList"
                :key="value">
                  <!-- No4:スキャナ保存対応「ファイル一覧_電子取引・スキャナ保存_フォルダ表示」画面で検索欄の文言変更(対象は「現在のフォルダ」または「現在のフォルダ以下」の場合) -->
                  <span v-if="index == 0" class="current-path-align">電子取引・スキャナ保存</span>
                  <span v-if="index > 0" class="current-path-align">&emsp;&gt;&emsp;</span>
                  <span v-if="index > 0" class="current-path-align current-path-text">{{value.folderName}}</span>
              </span>
              <span v-if="searchedTarget == '2'" class="current-path-align">&emsp;以下</span>
            </span>
            <!-- <span v-if="searchedTarget != '0' && this.currentFolderKeyList.length == 1">電子取引：　{{this.searchedKeyword}}</span>
            <span v-if="searchedTarget != '0' && this.currentFolderKeyList.length != 1">{{this.currentFolderKeyList[this.currentFolderKeyList.length - 1].folderName}}：　{{this.searchedKeyword}}</span> -->
          </div>
          <div v-if="!searchKeywordFlag && !searchFilterFlag && !inCompleteFilterFlag" class="current-path">
            <span ref="currentPathRyaku" class="current-path-align">≪&emsp;</span>
            <span name="currentPathSpanName" v-for="value, index in currentFolderKeyList"
              :key="value">
                <!-- <span style="padding-left: 20px; padding-right: 20px;" v-if="index > 0">&gt;</span> -->
                <!-- No4:スキャナ保存対応「ファイル一覧_電子取引・スキャナ保存_フォルダ表示」画面で検索欄の文言変更(初期表示) -->
                <span v-if="index == 0" class="current-path-value current-path-align" @click="openFolder(JSON.stringify(value))"
                  tabindex="0" @keydown.space.stop.prevent="openFolder(JSON.stringify(value))"
                  @keydown.enter="openFolder(JSON.stringify(value))">電子取引・スキャナ保存</span>
                <span v-if="index > 0" class="current-path-align" style="padding-left: 10px; padding-right: 10px;">&gt;</span>
                <span v-if="index > 0" class="current-path-value current-path-align current-path-text" 
                  @click="openFolder(JSON.stringify(value))"
                  tabindex="0" @keydown.space.stop.prevent="openFolder(JSON.stringify(value))"
                  @keydown.enter="openFolder(JSON.stringify(value))">
                  {{value.folderName}}
                </span>
            </span>
          </div>
          <button style="margin-left: auto;" v-show="this.show.btnLink" class="frm-btn-linkcopy" @click="copyToClipboard"></button>
        </div>
        <div style="margin-left: auto;" class="frm-item frm-label-wrap">
          <span class="frm-label">表示</span>
          <div class="frm-toggle frm-folder-toggle">
            <label>
              <input type="radio" v-model="displayMode" value="0" name="toggle1" @click="folderView" checked>
              <span class="ico-folder"></span>
            </label>
            <label>
              <input type="radio" v-model="displayMode" value="1" name="toggle1" @click="timeView">
              <span class="ico-time"></span>
            </label>
          </div>
        </div>
      </div>
      <div   class="frm-row">
        <div class="frm-item grow left">
          <div class="frm-item frm-label-wrap">
            <span v-if="!this.show.btnExport" class="frm-label">追加</span>
            <button v-if="this.show.btnNewFile" class="frm-btn-control strong ico ico-add-file" ref="refBtnNewFile"
                  @click="this.$refs.file.click()"
                  :disabled="!this.enabled.btnNewFile">
              <input style="display:none;"
                tabindex="-1"
                type="file"
                accept=".*"
                ref="file"
                @click="
                  (e) => {
                    e.target.value = '';
                  }
                "
                @change="selectedFile"
                multiple="multiple"
              />
            </button>
            <button v-if="this.show.btnNewFolder" class="frm-btn-control strong ico ico-add-folder"
              @click="btnNewFolder"
              :disabled="!this.enabled.btnNewFolder"></button>
          </div>
          <div class="frm-item frm-label-wrap">
            <span v-if="this.show.btnIkkatsu&&!this.show.btnExport" class="frm-label">処理方法</span>

            <div v-if="this.show.btnIkkatsu && !isMobile" class="select-other-wrap mouseover-menu">
              <button class="frm-btn-control frm-text frm-btn-text">一括処理</button>
              <div class="select-other left">
                <ul>
                  <li v-if="this.show.ikkatsuCopy" @click="this.ikkatsuSelectCopy">複写</li>
                  <li v-if="this.show.ikkatsuMove" @click="this.ikkatsuSelectMove">移動</li>
                  <li v-if="this.show.ikkatsuDownload" @click="this.ikkatsuSelectDownload">ダウンロード</li>
                  <li v-if="this.show.ikkatsuDelete" class="select-line" @click="this.ikkatsuSelectDelete">ごみ箱に移動</li>
                </ul>
              </div>
            </div>
            <div v-if="this.show.btnIkkatsu  && isMobile" class="select-other-wrap ">
              <button @click="(e)=>{handleBatchActionButtonClick(e)}" class="frm-btn-control frm-text frm-btn-text">一括処理</button>
            </div>
            <button v-if="this.show.btnExport" class="frm-btn-control frm-text frm-btn-text" @click="showHistoryExport">改訂履歴のエクスポート</button>
          </div>
        </div>
        <div  class="frm-item grow right">
          <div v-if="this.show.searchTarget">
            <span class="frm-label">対象</span>
            <select class="frm-select frm-size-mx" v-model="searchTarget" @change="changeSearchTarget">
              <option value="0">すべてのフォルダ</option>
              <option value="1">現在のフォルダ</option>
              <option value="2">現在のフォルダ以下</option>
            </select>
          </div>
          <div class="frm-search has-ico frm-size-l none-border-left" :class="{'setvalue': searchKeywordFlag}">
          <form action=""  @submit.prevent>
            <input
              ref="txtSearchKeyword"
              type="search"
              class="frm-search-text ico-blue"
              placeholder="検索キーワード"
              v-model.trim="searchKeyword"
              @keyup="selectSearchKeyword"
              maxlength="255">
          </form>
          </div>
          <div class="frm-item frm-label-wrap">
            <span v-if="!this.show.btnExport" class="frm-label">絞り込み</span>
            <button
              v-if="this.show.btnInComplete"
              class="frm-btn-control ico ico-alert-sort"
              :class="{'active':inCompleteFilterFlag}"
              @click="clickInCompleteFilter"></button>
            <button
              v-if="this.show.btnFilter"
              class="frm-btn-control ico ico-filter"
              :class="{'active':searchFilterFlag}"
              @click="clickShowFilter"></button>
            <button
              :disabled="!searchKeywordFlag && !searchFilterFlag && !inCompleteFilterFlag"
              class="frm-btn-control ico ico-filter-close"
              @click="clickClearFilter"></button>
          </div>
        </div>

      </div>
    </div>

    <div class="table-section">  
      <div ref="dropAreaDiv" class="frm-file" v-if="this.show.dropArea"
        v-show="this.dropArea.show" style="position:absolute;"
        @mouseout="dropArea.show = false"
        @dragover.prevent
        @drop.prevent="dropFile">
        <span class="frm-file-text">
          ファイルをドロップしてアップロード（複数のファイルのアップロードが可能です。）
        </span>
      </div>
      <div class="frm-item alignright" style="margin-top: 10px">
        <!-- <p v-show="inCompleteFilterFlag || searchKeywordFlag || searchFilterFlag">{{ collectedDocumentCount }}/{{ collectedDocumentAllCount }}件</p>
        <p v-show="!(inCompleteFilterFlag || searchKeywordFlag || searchFilterFlag)">{{ collectedDocumentCount }}件</p> -->
        <p class="align-left-p" v-show="(inCompleteFilterFlag || searchKeywordFlag || searchFilterFlag) && isSearchLimit">1,000件以上該当しました</p>
        <p class="align-left-p" v-show="(inCompleteFilterFlag || searchKeywordFlag || searchFilterFlag) && !isSearchLimit">{{ Number(collectedDocumentCount).toLocaleString('jp-JP') }}件該当しました</p>
        <p class="align-left-p" v-show="!(inCompleteFilterFlag || searchKeywordFlag || searchFilterFlag) && isSearchLimit">1,000件以上</p>
        <p class="align-left-p" v-show="!(inCompleteFilterFlag || searchKeywordFlag || searchFilterFlag) && !isSearchLimit">{{ Number(collectedDocumentCount).toLocaleString('jp-JP') }}件</p>
      </div>
      <!-- ******************************************************************
            *  ファイル一覧                                                  *
      ******************************************************************-->
      <div  class="table-wrap"
      
        @dragover.prevent="dragFile"
        style="margin-top: 0px">
        <table ref="fileListTable" class="table-select  table-multiCheckList">
          <colgroup>
            <col style="width: 40px;">
            <col style="width: 40px;">
            <!-- No4:スキャナ保存対応「ファイル一覧_電子取引・スキャナ保存」画面でデータ列の幅を変更 start-->
            <col class="auto-col" >
            <!-- <col style="width: 140px;"> -->
            <col v-show="this.show.fileListFolder" style="width: 100px;">
            <!-- <col style="width: 100px;"> -->
            <col style="width: 80px;">
            <col style="width: 100px;">
            <col style="width: 105px;">
            <col style="width: 150px;">
            <col style="width: 100px;">
            <col style="width: 60px;">
            <col style="width: 100px;">
            <col style="width: 100px;">
            <col style="width: 45px;">
            <!-- No4:スキャナ保存対応「ファイル一覧_電子取引・スキャナ保存」画面でデータ列の幅を変更  end-->
          </colgroup>
          <thead>
            <tr>
              <th>
              </th>
              <th class="multi-select-item">
                <label class="frm-checkbox">
                  <input ref="allCheckBox" type="checkbox" :checked="chkAllCheckFileList" @click="allCheckFileList" :disabled="collectedDocuments.length == 0">
                  <span v-if="collectedDocuments.length == 0" class="checkbox-item" tabindex="-1"></span>
                  <span v-if="collectedDocuments.length != 0" class="checkbox-item" tabindex="0" @keydown.space.stop.prevent="allCheckFileList"></span>
                </label>
              </th>
              <th class="alignleft sort hover"
                  @click="sortBy('name')">
                名称
                <div class="sort-toggle">
                  <button
                    class="sort-toggle-asc"
                    :class="sort.sortedNameClass == 1 ? 'on' : ''"
                    type="button"
                  >
                    asc
                  </button>
                  <button
                    class="sort-toggle-desc"
                    :class="sort.sortedNameClass == 2 ? 'on' : ''"
                    type="button"
                  >
                    desc
                  </button>
                </div>
              </th>
              <th v-show="this.show.fileListFolder" class="alignleft hover"
                  @click="sortBy('folder')">
                フォルダ
                <div class="sort-toggle">
                  <button
                    class="sort-toggle-asc"
                    :class="sort.sortedFolderClass == 1 ? 'on' : ''"
                    type="button"
                  >
                    asc
                  </button>
                  <button
                    class="sort-toggle-desc"
                    :class="sort.sortedFolderClass == 2 ? 'on' : ''"
                    type="button"
                  >
                    desc
                  </button>
                </div>
              </th>
              <!-- No4:スキャナ保存対応「ファイル一覧_電子取引・スキャナ保存_時系列表示」画面で書類ID列を追加 start-->
              <th class="aligncenter sort hover" @click="sortBy('paperID')">
                書類ID
                <div class="sort-toggle">
                  <button
                    class="sort-toggle-asc"
                    :class="sort.sortedPaperIDClass == 1 ? 'on' : ''"
                    type="button"
                  >
                    asc
                  </button>
                  <button
                    class="sort-toggle-desc"
                    :class="sort.sortedPaperIDClass == 2 ? 'on' : ''"
                    type="button"
                  >
                    desc
                  </button>
                </div>
              </th>
              <!-- No4:スキャナ保存対応「ファイル一覧_電子取引・スキャナ保存_時系列表示」画面で書類ID列を追加 end-->
              <th class="alignleft sort hover"
                  @click="sortBy('fileType')">
                書類種別
                <div class="sort-toggle">
                  <button
                    class="sort-toggle-asc"
                    :class="sort.sortedFileTypeClass == 1 ? 'on' : ''"
                    type="button"
                  >
                    asc
                  </button>
                  <button
                    class="sort-toggle-desc"
                    :class="sort.sortedFileTypeClass == 2 ? 'on' : ''"
                    type="button"
                  >
                    desc
                  </button>
                </div>
              </th>
              <th class="aligncenter sort hover"
                  @click="sortBy('tradingDate')">
                取引年月日
                <div class="sort-toggle">
                  <button
                    class="sort-toggle-asc"
                    :class="sort.sortedTradingDateClass == 1 ? 'on' : ''"
                    type="button"
                  >
                    asc
                  </button>
                  <button
                    class="sort-toggle-desc"
                    :class="sort.sortedTradingDateClass == 2 ? 'on' : ''"
                    type="button"
                  >
                    desc
                  </button>
                </div>
              </th>
              <th class="alignleft sort hover"
                  @click="sortBy('tradingName')">
                取引先
                <div class="sort-toggle">
                  <button
                    class="sort-toggle-asc"
                    :class="sort.sortedTradingNameClass == 1 ? 'on' : ''"
                    type="button"
                  >
                    asc
                  </button>
                  <button
                    class="sort-toggle-desc"
                    :class="sort.sortedTradingNameClass == 2 ? 'on' : ''"
                    type="button"
                  >
                    desc
                  </button>
                </div>
              </th>
              <th class="aligncenter sort hover"
                  @click="sortBy('amount')">
                取引金額
                <div class="sort-toggle">
                  <button
                    class="sort-toggle-asc"
                    :class="sort.sortedAmountClass == 1 ? 'on' : ''"
                    type="button"
                  >
                    asc
                  </button>
                  <button
                    class="sort-toggle-desc"
                    :class="sort.sortedAmountClass == 2 ? 'on' : ''"
                    type="button"
                  >
                    desc
                  </button>
                </div>
              </th>
              <th class="alignleft sort hover"
                  @click="sortBy('biko')">
                備考
                <div class="sort-toggle">
                  <button
                    class="sort-toggle-asc"
                    :class="sort.sortedBikoClass == 1 ? 'on' : ''"
                    type="button"
                  >
                    asc
                  </button>
                  <button
                    class="sort-toggle-desc"
                    :class="sort.sortedBikoClass == 2 ? 'on' : ''"
                    type="button"
                  >
                    desc
                  </button>
                </div>
              </th>
              <th class="alignleft sort hover"
                  @click="sortBy('updateName')">
                保存者
                <div class="sort-toggle">
                  <button
                    class="sort-toggle-asc"
                    :class="sort.sortedUpdateNameClass == 1 ? 'on' : ''"
                    type="button"
                  >
                    asc
                  </button>
                  <button
                    class="sort-toggle-desc"
                    :class="sort.sortedUpdateNameClass == 2 ? 'on' : ''"
                    type="button"
                  >
                    desc
                  </button>
                </div>
              </th>
              <th class="aligncenter sort hover"
                  @click="sortBy('updateDate')">
                保存日時
                <div class="sort-toggle">
                  <button
                    class="sort-toggle-asc"
                    :class="sort.sortedUpdateDateClass == 1 ? 'on' : ''"
                    type="button"
                  >
                    asc
                  </button>
                  <button
                    class="sort-toggle-desc"
                    :class="sort.sortedUpdateDateClass == 2 ? 'on' : ''"
                    type="button"
                  >
                    desc
                  </button>
                </div>
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="info in collectedDocuments"
              :key="info.fileId"
              :class="{
                selected: this.selectedFileIdList.includes(info.fileId)
              }"
            >
              <td class="aligncenter">
                <!-- <span v-if="info.lockUserName != ''" class="ico-tooltip" data-tooltip="{{info.lockUserName}}" data-tooltip-position="top"> -->
                <span v-if="info.lockUserName != ''" class="ico-tooltip" v-tooltip="{ title: '利用者：' + info.lockUserName, position: 'top' }">
                  <img src="../../assets/images/denchouhou/icon_editing.png" width="20" height="20" alt="利用者">
                </span>
              </td>
              <td class="alignleft">
                <label class="frm-checkbox">
                  <input v-bind:id="'chk' + info.fileId" type="checkbox" v-bind:value="info.fileId" v-model="selectedFileIdList" @click="selectRow(info)" />
                  <span class="checkbox-item" tabindex="0" @keydown.space.stop.prevent="selectRow(info)"></span>
                </label>
              </td>
              <td class="alignleft" v-if="info.listType == '1'"
                @click="selectRow(info)"
                @dblclick="info.listType == '0' ? openFile(info.fileKey) : openFolder(info.folderKey)">
                <div class="folder-name-wrap">
                  <div class="folder-state-wrap">
                    <span class="folder-state-ico"></span>
                    <span class="folder-state-ico ico-folder"></span>
                  </div>
                  <span>{{ info.fileName }}</span>
                </div>
              </td>
              <td class="alignleft" colspan="9" v-if="info.listType == '2'"
                @click="selectRow(info)">
                <div class="folder-name-wrap">
                  <div class="folder-state-wrap">
                    <span class="folder-state-ico ico-calendar"></span>
                  </div>
                  <span>{{ info.fileName }}</span>
                </div>
              </td>
              <td class="alignleft" v-if="info.listType == '0'"
                @click="selectRow(info)"
                @dblclick="info.listType == '0' ? openFile(info.fileKey) : openFolder(info.folderKey)">
                <div class="folder-name-wrap">
                  <div class="folder-state-wrap">
                    <span class="folder-state-ico" v-bind:class="{ 'ico-alert': isInComplete(info)}"></span>
                    <span class="folder-state-ico ico-file"></span>
                  </div>
                  <span>{{ info.fileName }}</span>
                </div>
              </td>
              <td class="alignleft" v-if="info.listType != '2'" v-show="this.show.fileListFolder"
                @click="selectRow(info)"
                @dblclick="info.listType == '0' ? openFile(info.fileKey) : openFolder(info.folderKey)">
                <span>{{ info.folderPath == "" ? "-" : info.folderPath }}</span>
              </td>
              <!-- No4:スキャナ保存対応 書類ID start -->
              <td class="alignright">
                <span>{{ info.paperID == "" ? "-" : info.paperID }}</span>
              </td>
              <!-- No4:スキャナ保存対応 書類ID end -->
              <td class="alignleft" v-if="info.listType != '2'"
                @click="selectRow(info)"
                @dblclick="info.listType == '0' ? openFile(info.fileKey) : openFolder(info.folderKey)">
                <span>{{ info.fileType == "" ? "-" : info.fileType }}</span>
              </td>
              <td class="aligncenter" v-if="info.listType != '2'"
                @click="selectRow(info)"
                @dblclick="info.listType == '0' ? openFile(info.fileKey) : openFolder(info.folderKey)">
                <span>{{ info.tradingDate == "" ? "-" : this.formatDate(info.tradingDate) }}</span>
              </td>
              <td class="alignleft" v-if="info.listType != '2'"
                @click="selectRow(info)"
                @dblclick="info.listType == '0' ? openFile(info.fileKey) : openFolder(info.folderKey)">
                <span>{{ info.tradingName == "" ? "-" : info.tradingName }}</span>
              </td>
              <td class="alignright" v-if="info.listType != '2'"
                @click="selectRow(info)"
                @dblclick="info.listType == '0' ? openFile(info.fileKey) : openFolder(info.folderKey)">
                <span>{{ info.tradingAmount == "" ? "-" : Number(info.tradingAmount).toLocaleString('jp-JP') + '円' }}</span>
              </td>
              <td class="aligncenter" v-if="!isMobile && info.listType != '2'">
                <span v-if="info.biko != ''" class="ico-tooltip" v-tooltip="{ title: info.biko, position: 'topleft' }">
                  <button tabindex="-1" class="frm-btn-tooltip"></button>
                </span>
                <span v-if="info.biko == ''">-</span>
              </td>
              <td class="aligncenter" v-if="isMobile && info.listType != '2'">
                <span v-if="info.biko != ''" class="ico-tooltip" @click.stop="handleRemarksModal(info.biko)">
                  <button tabindex="-1" class="frm-btn-tooltip"></button>
                </span>
                <span v-if="info.biko == ''">-</span>
              </td>
              <td class="alignleft" v-if="info.listType != '2'"
                @click="selectRow(info)"
                @dblclick="info.listType == '0' ? openFile(info.fileKey) : openFolder(info.folderKey)">
                <span>{{ info.updateName }}</span>
              </td>
              <td class="aligncenter" v-if="info.listType != '2'"
                @click="selectRow(info)"
                @dblclick="info.listType == '0' ? openFile(info.fileKey) : openFolder(info.folderKey)">
                <span>{{ formatDateTime(info.updateDate) }}</span>
              </td>
              <td v-if="!isMobile" class="aligncenter">
                <div v-if="info.listType == '0'" class="select-other-wrap mouseover-menu" v-on:mouseover="mouseOverAction">
                  <button class="btn-select-other" tabindex="-1">その他の項目</button>
                  <div class="select-other" data-role="select-menu">
                    <ul>
                      <li @click="openFile(info.fileKey)">開く</li>
                      <li v-show="this.show.listFileCopy" @click="selectCopy(info)">複写</li>
                      <li v-show="this.show.listFileMove" @click="selectMove(info)">移動</li>
                      <li v-show="this.show.listFileDownload" @click="selectDownload(info)">ダウンロード</li>
                      <li v-show="this.show.listFileOpenFolder" @click="openFolder(info.folderKey)">ファイルの場所を開く</li>
                      <li v-show="this.show.listFileDelete" @click="selectDelete(info)" class="select-line">ごみ箱に移動</li>
                    </ul>
                  </div>
                </div>
                <div v-if="info.listType == '1'" class="select-other-wrap mouseover-menu" v-on:mouseover="mouseOverAction">
                  <button class="btn-select-other" tabindex="-1">その他の項目</button>
                  <div class="select-other" data-role="select-menu">
                    <ul>
                      <li @click="openFolder(info.folderKey)">開く</li>
                      <li v-show="this.show.listFolderCopy" @click="selectCopy(info)">複写</li>
                      <li v-show="this.show.listFolderMove" @click="selectMove(info)">移動</li>
                      <li v-show="this.show.listFolderEdit" @click="selectFolderEdit(info.folderKey)">フォルダの編集</li>
                      <li v-show="this.show.listFolderDownload" @click="selectDownload(info)">ダウンロード</li>
                      <li v-show="this.show.listFolderDelete" @click="selectDelete(info)" class="select-line">ごみ箱に移動</li>
                    </ul>
                  </div>
                </div>
              </td>
              <td v-if="isMobile " class="aligncenter"  @click.stop="(e)=>{handleActionButtonClick(e,info)}">
                <div v-if="info.listType == '0' || info.listType == '1'" class="select-other-wrap mouseover-menu" >
                  <button class="btn-select-other" tabindex="-1">その他の項目</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <table class="table-select single-select" v-show="noDataPrompt">
          <tbody>
            <tr>
              <p class="noData-area">
                {{ noDataMsg }}
              </p>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <SFMFileUpload
    :pageId="pageId"
    @confirm="confirm">
  </SFMFileUpload>
  <!-- No4スキャナ保存対応 :showCheckedColumn="STFMFM02C16Modle.showCheckedColumn" -->
  <STFMFM02C16FileUploadComfirm
    ref="refSTFMFM02C16FileUploadComfirm"
    :isFileUploadDlgShow=STFMFM02C16Modle.isFileUploadDlgShow
    :uploadFiles=STFMFM02C16Modle.uploadFiles
    @confirm="confirm"
    @disagree="disagree">
  </STFMFM02C16FileUploadComfirm>
  <STFMFM02C21CopyMoveModal
    :isCopyMoveShow=STFMFM02C21Modle.isCopyMoveShow
    :moveFlg=STFMFM02C21Modle.moveFlg
    :srcFileList=STFMFM02C21Modle.srcFileList
    :srcFolderList=STFMFM02C21Modle.srcFolderList
    :isTzuser=STFMFM02C21Modle.isTzuser
    :fmFolderOperation=STFMFM02C21Modle.fmFolderOperation
    :fmFileOperation=STFMFM02C21Modle.fmFileOperation
    @close-stfmf02c21="closeSTFMF02C21">
  </STFMFM02C21CopyMoveModal>
  <STFMFM02C19ConfirmDeleteETF
    :isETFDeleteConfirmShow=STFMFM02C19Modle.isETFDeleteConfirmShow
    :folderKeyList=STFMFM02C19Modle.folderKeyList
    :fileKeyList=STFMFM02C19Modle.fileKeyList
    :isTzuser=STFMFM02C19Modle.isTzuser
    :fmFolderOperation=STFMFM02C19Modle.fmFolderOperation
    :fmFileOperation=STFMFM02C19Modle.fmFileOperation
    @agreeDeleteETFFile="agreeDeleteETFFile"
    @disagreeDeleteETFFile="disagreeDeleteETFFile">
  </STFMFM02C19ConfirmDeleteETF>
  <STFMFM02C08ConfirmDialog 
        :isShow="isShowLinkCopy"
        :message="linkCopyMsg"
        :cancelText="''"
        @confirm="isShowLinkCopy = false"
        >
  </STFMFM02C08ConfirmDialog>
  <STFMFM02C08ConfirmDialog 
        :isShow="isShowSearchLimit"
        :message="searchLimitMsg"
        :cancelText="''"
        @confirm="isShowSearchLimit = false"
        >
  </STFMFM02C08ConfirmDialog>
  <STFMFM02C08ConfirmDialog 
        :isShow="isShowHistoryExport"
        :message="historyExportMsg"
        :confirmText="'はい'"
        :cancelText="'いいえ'"
        @confirm="execHistoryExport"
        @cancel="isShowHistoryExport = false"
        >
  </STFMFM02C08ConfirmDialog>
  <STFMFM02C11FilterCompleteModal 
        ref="refSTFMFM02C11FilterCompleteModal"
        :isShow="STFMFM02C11Filter.isShow"
        :loginSystem="STFMFM02C11Filter.loginSystem"
        :STFMFM02C11FilterInit="STFMFM02C11Filter.STFMFM02C11FilterInit"
        @filterSTFMFM02C11="filterSTFMFM02C11"
        @canceFilterSTFMFM02C11="canceFilterSTFMFM02C11"
        >
  </STFMFM02C11FilterCompleteModal>
  <BaseModal :show="remarksModal.show">
    <div class="popup">
      <div class="popup-head bg-colore-gray">備考</div>
      <div class="popup-body">
        <div class="popup-status">
         {{remarksModal.text}}
        </div>
        <div class="frm-btn-row">
          <div class="frm-item grow center">
            <button
              tabindex="0"
              class="frm-btn strong large"
              @click="remarksModal={show:false,text:''}"
              ref="closeButton"
            >
              閉じる
            </button>
          </div>
        </div>
      </div>
    </div>
  </BaseModal>
  <!-- No4スキャナ保存対応 start-->
  <!-- <ConfirmDialog :isShow="showCheckConfirmDialog" :message="checkConfirmDialogContent" @confirm="handleDialogConfirm" @cancel="handleDialogCancel"></ConfirmDialog> -->
  <!-- No4スキャナ保存対応 end-->
  <div class="mask" v-if="showMask" @touchmove.prevent @click="closeMask('showMask')">
    <div  v-if="currentInfo.listType == '0'"  :style="dropMeauPositon"   class="drop-meau select-other" data-role="select-menu">
      <ul>
        <li @click="openFile(currentInfo.fileKey)">開く</li>
        <li v-show="this.show.listFileCopy" @click="selectCopy(currentInfo)">複写</li>
        <li v-show="this.show.listFileMove" @click="selectMove(currentInfo)">移動</li>
        <li v-show="this.show.listFileDownload" @click="selectDownload(currentInfo)">ダウンロード</li>
        <li v-show="this.show.listFileOpenFolder" @click="openFolder(currentInfo.folderKey)">ファイルの場所を開く</li>
        <li v-show="this.show.listFileDelete" @click="selectDelete(currentInfo)" class="select-line">ごみ箱に移動</li>
      </ul>
    </div>
    <div v-if="currentInfo.listType == '1'" :style="dropMeauPositon" class="drop-meau select-other" data-role="select-menu">
      <ul>
        <li @click="openFolder(currentInfo.folderKey)">開く</li>
        <li v-show="this.show.listFolderCopy" @click="selectCopy(currentInfo)">複写</li>
        <li v-show="this.show.listFolderMove" @click="selectMove(currentInfo)">移動</li>
        <li v-show="this.show.listFolderEdit" @click="selectFolderEdit(currentInfo.folderKey)">フォルダの編集</li>
        <li v-show="this.show.listFolderDownload" @click="selectDownload(currentInfo)">ダウンロード</li>
        <li v-show="this.show.listFolderDelete" @click="selectDelete(currentInfo)" class="select-line">ごみ箱に移動</li>
      </ul>
    </div>
  </div>
  <div class="mask" v-if="showBatchMenuMask" @touchmove.prevent @click="closeMask('showBatchMenuMask')">
    <div class="drop-meau select-other" :style="dropMeauPositon">
      <ul>
        <li v-if="this.show.ikkatsuCopy" @click="this.ikkatsuSelectCopy">複写</li>
        <li v-if="this.show.ikkatsuMove" @click="this.ikkatsuSelectMove">移動</li>
        <li v-if="this.show.ikkatsuDownload" @click="this.ikkatsuSelectDownload">ダウンロード</li>
        <li v-if="this.show.ikkatsuDelete" class="select-line" @click="this.ikkatsuSelectDelete">ごみ箱に移動</li>
      </ul>
    </div>
  </div>

</template>
<script>
import _ from "lodash";
import moment from "moment";
import Common from "@/util/common.js";
import Validation from "@/util/validation.js";
import { mapGetters, mapMutations } from "vuex";
import {
  convert_to_gemmdd,
  warekiToYear,
} from "@/util/dateFormat.js";
import SFMFileUpload from "@/components/SFMFileUpload.vue";
import { truncateSync } from "fs";
import { validate } from "json-schema";
import { downloadAsOtherNameApi } from "@/api/filemanage_download"
import STFMFM02C11FilterCompleteModal from "@/components/STFMFM02C11FilterCompleteModal.vue";
import STFMFM02C16FileUploadComfirm from "@/components/STFMFM02C16FileUploadComfirm.vue";
import STFMFM02C21CopyMoveModal from "@/components/STFMFM02C21CopyMoveModal.vue";
import STFMFM02C19ConfirmDeleteETF from "@/components/STFMFM02C19ConfirmDeleteETF.vue";
import STFMFM02C08ConfirmDialog from "../../components/STFMFM02C08ConfirmDialog.vue";
import BaseModal from "@/components/Base/BaseModal.vue";

// No4スキャナ保存対応
// import ConfirmDialog from "@/components/ConfirmDialog.vue";
import { API_STFMFM02C02_Initialize, API_STFMFM02C02_OpneFIlePreview,API_STFMFM02C02_EditFolderPreview,API_STFMFM02C02_CheckFile,API_STFMFM02C02_SearchFileList,API_STFMFM02C02_Download,API_STFMFM02C02_Export,API_STFMFM02C02_Encrypt, API_STFMFM02C02_SetFilter} from "@/api/Modules/FM02/STFMFM02C02.js";
import {
  FILTER_VIEWS_DISPLAY_FLAG_LIST,
  SEARCH_TARGET_CODE_LIST,
  DEALINGINFO_INPUT_STATUS_CODE_LIST,
  FILE_NAME_CODE_LIST,
  PAPER_TYPE_CODE_LIST,
  ISSUE_DATE_CODE_LIST,
  COMPANY_CODE_LIST,
  AMOUNT_CODE_LIST,
  REMARKS_CODE_LIST,
  UPDATER_CODE_LIST,
  YEAR_LIST,
  SearchTargetCodeValue,
  DealinginfoInputStatusCodeValue,
  FileNameCodeValue,
  PaperIdCodeValue,  // No4:スキャナ保存対応 書類ID
  PaperTypeCodeValue,
  IssueDateCodeValue,
  CompanyCodeValue,
  AmountCodeValue,
  RemarksCodeValue,
  UpdaterCodeValue,
  GengoCodeValue,
} from "@/util/data.js";
export default {
  name: "STFMFM02C02",
  components: {
    SFMFileUpload,
    STFMFM02C16FileUploadComfirm,
    STFMFM02C21CopyMoveModal,
    STFMFM02C19ConfirmDeleteETF,
    STFMFM02C08ConfirmDialog,
    STFMFM02C11FilterCompleteModal,
    BaseModal
    // ConfirmDialog //No4スキャナ保存対応
},
  data() {
    return {
      showMask:false,
      showBatchMenuMask:false,
      currentInfo:{},
      dropMeauPositon:{
        left:0,
        top:0
      },
      STFMFM02C11Filter:{
        isShow: false,
        STFMFM02C11FilterInit: {},
      },
      businessOperatorId:0,
      businessOperatorCode:"",
      businessOperatorName:"",
      STFMFM02C16Modle:{},
      STFMFM02C19Modle:{},
      STFMFM02C21Modle:{},
      sessionID: "",
      allData: [],
      collectedDocuments: [],
      collectedDocumentCount: 0,
      collectedDocumentAllCount: 0,
      CollectDataList: [],
      errors: [],
      //ハイライト
      highlights: [],
      highlightIndex: -1,
      isSearchKeyEnter: false,
      execType: [""],
      files: [],
      dropArea: {
        show: false,
        top: 0,
        left: 0,
        height: 0,
        width: 0
      },
      selectedFileIdList: [], // 選択ログインIDリスト
      currentPath: "",
      currentPathSplit : [],
      currentFolderKey : "",
      encryptFolderKey: "",
      currentFolderKeyList :[],
      currentPathMaxFlag: false,
      displayMode: "0",
      searchTarget: "1",
      searchKeyword: "",
      searchedTarget: "1",
      searchedKeyword: "",
      inCompleteFilterFlag: false,
      searchKeywordFlag: false,
      searchFilterFlag: false,
      isFilterShow: false,
      noDataPrompt: false,
      STFMFM02C11FilterInit: {
        searchTaget: SearchTargetCodeValue.CurrentFolder,
        keyWord: "",
        dealinginfoInputStatus: DealinginfoInputStatusCodeValue.All,
        fileName: FileNameCodeValue.All,
        fileNameInput: "",
        // No4:スキャナ保存対応 書類ID
        paperID: PaperIdCodeValue.All, 
        paperIdInput: "",
        paperType: PaperTypeCodeValue.All,
        paperTypeInput: "",
        issueDate: IssueDateCodeValue.All,
        issueDateGengoFromInput: GengoCodeValue.Reiwa,
        issueDateYearFromInput: "",
        issueDateMonthFromInput: "",
        issueDateDayFromInput: "",
        issueDateGengoToInput: GengoCodeValue.Reiwa,
        issueDateYearToInput: "",
        issueDateMonthToInput: "",
        issueDateDayToInput: "",
        company: CompanyCodeValue.All,
        companyInput: "",
        amount: AmountCodeValue.All,
        amountFromInput: "",
        amountToInput: "",
        remarks: RemarksCodeValue.All,
        remarksInput: "",
        updater: UpdaterCodeValue.All,
        updaterInput: ""
      },
      ViewFileKeyList: [],
      userType: "0", // ユーザの種類
      userFolderFileAuthFlag : false, //ユーザのフォルダ・ファイルの操作権限
      userFileAuthFlag : false, //ユーザのファイルの操作権限
      userDownloadAuthFlag : false, //ユーザのダウンロードの操作権限
      // keywordEnterFlag: false,
      noDataMsg: Common.getMessage("MTCL1118", ["ファイル"]),　//検索結果0件時のメッセージ
      chkAllCheckFileList: false,
      isSearchLimit: false,
      isShowLinkCopy: false,
      linkCopyMsg: Common.getMessage("MTFM5010"),
      isShowSearchLimit: false,
      searchLimitMsg: Common.getMessage("MTFM5040"),
      isShowHistoryExport: false,
      historyExportMsg: Common.getMessage("MTFM5050"),
      sort: {
        indexName: 2, // 名称
        // No4:スキャナ保存対応「ファイル一覧_電子取引・スキャナ保存_フォルダ表示」画面で書類IDのsortを追加
        indexPaperID: 2, // 書類ID
        indexFileType: 2, // ファイル種類
        indexFolder: 2, // フォルダ
        indexTradingDate: 2, // 取引年月日
        indexTradingName: 2, // 取引先
        indexAmount: 2, // 取引金額
        indexUpdateName: 2, // 保存者
        indexBiko: 2, // 備考
        indexUpdateDate: 1, // 保存日時
        sortedNameClass: 0, // 名称CSSスタイルクラス
        // No4:スキャナ保存対応「ファイル一覧_電子取引・スキャナ保存_フォルダ表示」画面で書類IDのsortを追加
        sortedPaperIDClass: 0, // 書類ID CSSスタイルクラス
        sortedFileTypeClass: 0, // ファイル種類CSSスタイルクラス
        sortedFolderClass: 0, // フォルダCSSスタイルクラス
        sortedTradingDateClass: 0, // 取引年月日CSSスタイルクラス
        sortedTradingNameClass: 0, // 取引先CSSスタイルクラス
        sortedAmountClass: 0, // 取引金額CSSスタイルクラス
        sortedUpdateNameClass: 0, // 保存者CSSスタイルクラス
        sortedBikoClass: 0, // 備考CSSスタイルクラス
        sortedUpdateDateClass: 0, // 保存日時CSSスタイルクラス
        key: "", // ソートキー
        isAsc: false, // 昇順ならtrue,降順ならfalse
      },
      show: {
        currentPath: true, //フォルダパス表示
        btnLink: true, //リンク取得
        btnNewFile: true, //ファイル新規作成
        btnNewFolder: true, //ファイル新規作成
        btnExport: false, //改訂履歴エクスポート
        searchTarget : true, //検索対象
        btnInComplete: true, //取引情報登録未完了フィルタ
        btnFilter: true, //フィルター
        serachTarget: true, //検索対象
        btnIkkatsu: true, //一括処理ボタン
        ikkatsuCopy: true, //一括処理複写
        ikkatsuMove: true, //一括処理移動
        ikkatsuDownload: true, //一括処理ダウンロード
        ikkatsuDelete: true, //一括処理削除
        listFolderCopy: true, //一覧フォルダ複写
        listFolderMove: true, //一覧フォルダ移動
        listFolderDownload: true, //一覧フォルダダウンロード
        listFolderEdit: true, //一覧フォルダ編集
        listFolderDelete: true, //一覧フォルダ削除
        listFileCopy: true, //一覧ファイル複写
        listFileMove: true, //一覧ファイル移動
        listFileDownload: true, //一覧ファイルダウンロード
        listFileDelete: true, //一覧ファイル削除
        listFileExport: true, //一覧改訂履歴エクスポート
        listFileOpenFolder: true, //一覧ファイルの場所を開く
        fileListFolder: true, //ファイル一覧のフォルダ欄
        dropArea: true,
      },
      enabled: {
        btnNewFile: true, //ファイル新規作成
        btnNewFolder: true, //ファイル新規作成
      },
      // No4スキャナ保存対応
      // showCheckConfirmDialog:false,
      // checkConfirmDialogContent:"スキャナ保存の読取要件を満たしているか\nチェックしますか？"
      isMobile:Common.isMobile(),
      remarksModal:{
        show:false,
        text:""
      }
    };
  },
  watch: {
    searchKey: {
      handler: "filterContext",
      immediate: true,
    },
  },
  computed: {
    ...mapGetters("businessModule", ["isDeleteShow"]),

  },
  methods: {
    ...mapMutations("businessModule", ["confirmDialogue", "uploadDialogue", "uploadCmfDialogue", "processDialogue","updateDataSpaceUsedChangeFlag"]),
    disagree(){
      this.STFMFM02C16Modle.isFileUploadDlgShow = false;
      this.$refs.refSTFMFM02C16FileUploadComfirm.isUploadDlgShow = false;
      // this.$nextTick(function () {
      //   this.initFocus();
      // });
      this.refreshFileList();
    },
    // フォルダ表示
    folderView() {
      if (this.displayMode != "0") {
        this.errors = [];
        this.setErrors();

        this.displayMode = "0";
        this.clearFilter();
        this.clearSort();
        this.selectedFileIdList = [];
        this.chkAllCheckFileList = false;
        this.serachFileList();
      }
    },

    // 時系列表示
    timeView() {
      if (this.displayMode != "1") {
        this.errors = [];
        this.setErrors();

        this.displayMode = "1";
        this.clearFilter();
        this.clearSort();
        this.selectedFileIdList = [];
        this.chkAllCheckFileList = false;
        this.serachFileList();
      }
    },

    // 一括複写選択
    ikkatsuSelectCopy() {
      if (this.ikkatsuErrorCheck("1")){
        this.selectCopy();
      }
    },
    // 一括移動選択
    ikkatsuSelectMove() {
      if (this.ikkatsuErrorCheck("2")){
        this.selectMove();
      }
    },
    // 一括ダウンロード選択
    ikkatsuSelectDownload() {
      if (this.ikkatsuErrorCheck("3")){
        this.execDownload();
      }
    },
    // 一括複写選択
    ikkatsuSelectDelete() {
      if (this.ikkatsuErrorCheck("4")){
        this.selectDelete();
      }
    },

    // 複写選択
    selectCopy(e) {
      this.errors = [];
      this.setErrors();

      let selectedFileKeyList = [];
      let selectedFolderKeyList = [];

      if (e == null || e == "") {
        for (var i = 0 ; i < this.collectedDocuments.length ; i++) {
          if (this.selectedFileIdList.includes(this.collectedDocuments[i].fileId)) {
            if (this.collectedDocuments[i].listType == "0") {
              selectedFileKeyList.push(this.collectedDocuments[i].fileKey);
            } else if (this.collectedDocuments[i].listType == "1") {
              selectedFolderKeyList.push(this.collectedDocuments[i].folderKey);
            }
          }
        }
      } else {
        if (e.listType == "0") {
          selectedFileKeyList.push(e.fileKey);
        } else if (e.listType == "1") {
          selectedFolderKeyList.push(e.folderKey);
        }
      }

      this.STFMFM02C21Modle={
        isCopyMoveShow : true,
        moveFlg : false,
        srcFileList : selectedFileKeyList,
        srcFolderList: selectedFolderKeyList,
        isTzuser: this.userType == "0" ? true : false,
        fmFolderOperation: this.userFolderFileAuthFlag,
        fmFileOperation: this.userFileAuthFlag
      }
    },
    // 移動選択
    selectMove(e) {
      this.errors = [];
      this.setErrors();

      let selectedFileKeyList = [];
      let selectedFolderKeyList = [];

      if (e == null || e == "") {
        for (var i = 0 ; i < this.collectedDocuments.length ; i++) {
          if (this.selectedFileIdList.includes(this.collectedDocuments[i].fileId)) {
            if (this.collectedDocuments[i].listType == "0") {
              selectedFileKeyList.push(this.collectedDocuments[i].fileKey);
            } else if (this.collectedDocuments[i].listType == "1") {
              selectedFolderKeyList.push(this.collectedDocuments[i].folderKey);
            }
          }
        }
      } else {
        if (e.listType == "0") {
          selectedFileKeyList.push(e.fileKey);
        } else if (e.listType == "1") {
          selectedFolderKeyList.push(e.folderKey);
        }
      }

      this.STFMFM02C21Modle={
        isCopyMoveShow : true,
        moveFlg : true,
        srcFileList : selectedFileKeyList,
        srcFolderList: selectedFolderKeyList,
        isTzuser: this.userType == "0" ? true : false,
        fmFolderOperation: this.userFolderFileAuthFlag,
        fmFileOperation: this.userFileAuthFlag
      }
    },
    // 複写・移動画面閉じる
    closeSTFMF02C21(iscansel){
      this.STFMFM02C21Modle.isCopyMoveShow = false;
      this.refreshFileList();
      // No8データ容量表示領域更新対応
      this.updateDataSpaceUsedChangeFlag(true)
    },

    // ダウンロード選択
    selectDownload(e) {
      this.errors = [];
      this.setErrors();
      
      this.execDownload(e);
    },

    // 削除選択
    selectDelete(e) {
      this.errors = [];
      this.setErrors();

      let selectedFileKeyList = [];
      let selectedFolderKeyList = [];

      if (e == null || e == "") {
        for (var i = 0 ; i < this.collectedDocuments.length ; i++) {
          if (this.selectedFileIdList.includes(this.collectedDocuments[i].fileId)) {
            if (this.collectedDocuments[i].listType == "0") {
              selectedFileKeyList.push(this.collectedDocuments[i].fileKey);
            } else if (this.collectedDocuments[i].listType == "1") {
              selectedFolderKeyList.push(this.collectedDocuments[i].folderKey);
            }
          }
        }
      } else {
        if (e.listType == "0") {
          selectedFileKeyList.push(e.fileKey);
        } else if (e.listType == "1") {
          selectedFolderKeyList.push(e.folderKey);
        }
      }

      this.STFMFM02C19Modle={
        isETFDeleteConfirmShow: true,
        folderKeyList: selectedFolderKeyList,
        fileKeyList: selectedFileKeyList,
        isTzuser: this.userType == "0" ? true : false,
        fmFolderOperation: this.userFolderFileAuthFlag,
        fmFileOperation: this.userFileAuthFlag
      }
    },

    agreeDeleteETFFile() {
      this.STFMFM02C19Modle.isETFDeleteConfirmShow = false;
      this.refreshFileList();
    },

    disagreeDeleteETFFile() {
      this.STFMFM02C19Modle.isETFDeleteConfirmShow = false;
    },

    // フォルダの編集選択
    selectFolderEdit(folderKey) {
      this.errors = [];
      this.setErrors();

      this.processDialogue(true);

      let params = {
        selectFolderKey: folderKey,
        
        displayMode: this.displayMode,
        searchTarget: this.searchTarget,
        searchKeyword: this.searchKeyword,
        inCompleteFilterFlag: this.inCompleteFilterFlag
      };

      API_STFMFM02C02_EditFolderPreview(params).then(
        (response) => {
          if (response.result == "0000") {
            //正常時
            
            //フォルダ編集画面を開く
            this.$router.push({
              name: "STFMFM02C06",
              params: {}
            });

          } else {
            // エラー表示
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [])
              )
            );
          }
          this.setErrors();
        this.processDialogue(false);
        }
      );
    },
    
    // クリップボードコピー選択
    copyToClipboard() {
      this.errors = [];
      this.setErrors();

      // this.errors.push(Common.createError(
      //         "MTFM5010",
      //         Common.getMessage("MTFM5010")
      //       ));
      
      var url = new URL(location.href);
      url.searchParams.delete('cp');
      url.searchParams.set('cp', this.encryptFolderKey);

      navigator.clipboard.writeText(url.toString());
      // this.setErrors();
      this.isShowLinkCopy = true;
    },

    changeSearchTarget() {
      if (this.inCompleteFilterFlag || this.searchKeywordFlag || this.searchFilterFlag) {
        // this.keywordEnterFlag = true;
        this.selectSearchKeyword();
      }
    },

    // // キーワード設定後エンター
    // selectSearchKeywordEnter(e) {
    //   // this.keywordEnterFlag = true;
    //   // console.log('selectSearchKeywordEnter');
    //   // this.errors = [];
    //   // this.setErrors();
      
    //   // // 検索時のフラグ設定
    //   // this.searchKeywordFlag = true;

    //   // if (e != null) {
    //   //   this.searchKeyword = e.target.value;
    //   // }
    //   // this.clearSort();
    //   // this.serachFileList();
    // },

    selectSearchKeyword(e) {
      if(e && e.keyCode !== 13 ){
        return 
      }
      this.$refs.txtSearchKeyword.blur()
      this.errors = [];
      this.setErrors();

      // if (this.searchKeyword != "") {
      //   // 検索時のフラグ設定
      //   this.searchKeywordFlag = true;
      this.searchKeywordFlag = this.searchKeyword != "" ? true : false;
        // if (e != null) {
        //   this.searchKeyword = e.target.value;
        // }
      this.clearSort();
      this.serachFileList();
      // } else {
      //   this.clickClearFilter();
      // }
      // this.keywordEnterFlag = false;
    },

    //取引情報登録未完了フィルタ
    clickInCompleteFilter() {
      this.errors = [];
      this.setErrors();

      this.inCompleteFilterFlag = !this.inCompleteFilterFlag;
      if (this.inCompleteFilterFlag) {
        this.STFMFM02C11FilterInit.dealinginfoInputStatus = DealinginfoInputStatusCodeValue.Unfinished;
        this.searchFilterFlag = this.isSTFMFM02C11Filter();
      }
      this.clearSort();
      this.serachFileList();
    },

    filterSTFMFM02C11(){
      this.STFMFM02C11Filter.isShow = false;
      this.STFMFM02C11FilterInit = this.$refs.refSTFMFM02C11FilterCompleteModal.$data.searchConditionInfo;
      this.searchKeyword = this.STFMFM02C11FilterInit.keyWord;
      this.inCompleteFilterFlag = this.STFMFM02C11FilterInit.dealinginfoInputStatus == DealinginfoInputStatusCodeValue.Unfinished;
      this.searchTarget = this.STFMFM02C11FilterInit.searchTaget;

      this.searchKeywordFlag = this.searchKeyword != "" ? true : false ;
      this.searchFilterFlag = this.isSTFMFM02C11Filter();

      this.clearSort();
      this.serachFileList();
    },
    canceFilterSTFMFM02C11(){
      this.STFMFM02C11Filter.isShow = false;
    },
    // フィルタ画面
    clickShowFilter() {
      this.errors = [];
      this.setErrors();
      // var filterC11 = this.$refs.refSTFMFM02C11FilterCompleteModal.$data.searchConditionInfo
      this.STFMFM02C11FilterInit.keyWord = this.searchKeyword;
      if (this.inCompleteFilterFlag) {
        this.STFMFM02C11FilterInit.dealinginfoInputStatus = DealinginfoInputStatusCodeValue.Unfinished;
      } else {
        if (this.STFMFM02C11FilterInit.dealinginfoInputStatus != DealinginfoInputStatusCodeValue.Finished) {
          this.STFMFM02C11FilterInit.dealinginfoInputStatus = DealinginfoInputStatusCodeValue.All;
        }
      }
      this.STFMFM02C11FilterInit.searchTaget = this.searchTarget;

      this.STFMFM02C11Filter.STFMFM02C11FilterInit = this.STFMFM02C11FilterInit;
      if(this.displayMode && this.displayMode == "0"){
        this.STFMFM02C11Filter.STFMFM02C11FilterInit.pageID = "STFMFM02C11";
      }
      else{
        this.STFMFM02C11Filter.STFMFM02C11FilterInit.pageID = "STFMFM02C12";
      }
      this.STFMFM02C11Filter.isShow=true;

    },

    // フィルター解除
    clickClearFilter() {
      this.errors = [];
      this.setErrors();

      this.clearFilter();
      this.clearSort();
      this.serachFileList();
    },
    // フィルタクリア
    clearFilter() {
      this.searchKeyword = "";
      this.inCompleteFilterFlag = false;
      this.searchTarget = "1";
      this.searchKeywordFlag = false;
      this.searchFilterFlag = false;
      
      this.STFMFM02C11FilterInit.searchTaget = SearchTargetCodeValue.CurrentFolder;
      this.STFMFM02C11FilterInit.keyWord = "";
      this.STFMFM02C11FilterInit.dealinginfoInputStatus = DealinginfoInputStatusCodeValue.All;
      this.STFMFM02C11FilterInit.fileName = FileNameCodeValue.All;
      this.STFMFM02C11FilterInit.fileNameInput = "";
      // No4:スキャナ保存対応 書類ID
      this.STFMFM02C11FilterInit.paperID = PaperIdCodeValue.All;
      this.STFMFM02C11FilterInit.paperIdInput = "";
      this.STFMFM02C11FilterInit.paperType = PaperTypeCodeValue.All;
      this.STFMFM02C11FilterInit.paperTypeInput = "";
      this.STFMFM02C11FilterInit.issueDate = IssueDateCodeValue.All;
      this.STFMFM02C11FilterInit.issueDateGengoFromInput = GengoCodeValue.Reiwa;
      this.STFMFM02C11FilterInit.issueDateYearFromInput = "";
      this.STFMFM02C11FilterInit.issueDateMonthFromInput = "";
      this.STFMFM02C11FilterInit.issueDateDayFromInput = "";
      this.STFMFM02C11FilterInit.issueDateGengoToInput = GengoCodeValue.Reiwa;
      this.STFMFM02C11FilterInit.issueDateYearToInput = "";
      this.STFMFM02C11FilterInit.issueDateMonthToInput = "";
      this.STFMFM02C11FilterInit.issueDateDayToInput = "";
      this.STFMFM02C11FilterInit.company = CompanyCodeValue.All;
      this.STFMFM02C11FilterInit.companyInput = "";
      this.STFMFM02C11FilterInit.amount = AmountCodeValue.All;
      this.STFMFM02C11FilterInit.amountFromInput = "";
      this.STFMFM02C11FilterInit.amountToInput = "";
      this.STFMFM02C11FilterInit.remarks = RemarksCodeValue.All;
      this.STFMFM02C11FilterInit.remarksInput = "";
      this.STFMFM02C11FilterInit.updater = UpdaterCodeValue.All;
      this.STFMFM02C11FilterInit.updaterInput = "";

      this.saveFilter();
    },
    clearSort() {
      // 「▲」、「▼」クラスを削除
      this.sort.sortedNameClass = 0;
      // No4:スキャナ保存対応「ファイル一覧_電子取引・スキャナ保存_フォルダ表示」画面で書類IDのsortを追加
      this.sort.sortedPaperIDClass = 0;
      this.sort.sortedFileTypeClass = 0;
      this.sort.sortedFolderClass = 0;
      this.sort.sortedTradingDateClass = 0;
      this.sort.sortedTradingNameClass = 0;
      this.sort.sortedAmountClass = 0;
      this.sort.sortedUpdateNameClass = 0;
      this.sort.sortedBikoClass = 0;
      this.sort.sortedUpdateDateClass = 0;
      // 既定値に戻す
      this.sort.indexName = 2;
      // No4:スキャナ保存対応「ファイル一覧_電子取引・スキャナ保存_フォルダ表示」画面で書類IDのsortを追加
      this.sort.indexPaperID = 2;
      this.sort.indexFileType = 2;
      this.sort.indexFolder = 2;
      this.sort.indexTradingDate = 2;
      this.sort.indexTradingName = 2;
      this.sort.indexAmount = 2;
      this.sort.indexUpdateName = 2;
      this.sort.indexBiko = 2;
      this.sort.indexUpdateDate = 1;
    },
    // **********************************************
    // * 日付のフォーマット(gemmdd)
    // **********************************************
    formatDate(value) {
      if (value) {
        // const year = value.substring(0, 4);
        // const month = value.substring(4, 6);
        // const day = value.substring(6, 8);
        // return convert_to_gemmdd(new Date(year.concat("/").concat(month).concat("/").concat(day)), 2, 2);
        return convert_to_gemmdd(new Date(value), 2, 2);
      }
    },
    // **********************************************
    // * 日付のフォーマット(YYYY/MM/DD HH:mm:ss)
    // **********************************************
    formatDateTime(value) {
      if (value) {
        return moment(String(value)).format("YYYY/MM/DD HH:mm:ss");
      }
    },
    formatDateTimeInt(value) {
      if (value) {
        return moment(String(value)).format("YYYYMMDD HHmmss");
      }
    },
    formatDateYYYMMDD(value) {
      if (value) {
        return moment(String(value)).format("YYYYMMDD");
      } else {
        return "";
      }
    },
    // **********************************************
    // * 行選択
    // **********************************************
    selectRow(info) {
      if (info.listType == "2") {
        if (this.selectedFileIdList.includes(info.fileId)) {
          this.checkTimeKbn(info.timeKbn, false);
        } else {
          this.checkTimeKbn(info.timeKbn, true);
        }
      } else {
        if (this.selectedFileIdList.includes(info.fileId)) {
          let index = this.selectedFileIdList.indexOf(info.fileId);
          
          this.selectedFileIdList.splice(index, 1);
        } else {
          this.selectedFileIdList.push(info.fileId);
        }
      }
      this.checkTimeKbnHeader(info.timeKbn);
      this.chkAllCheckFileList = this.isAllCheckFileList();
    },

    allCheckFileList() {
      this.chkAllCheckFileList = !this.chkAllCheckFileList;
      if (this.chkAllCheckFileList) {
        this.selectedFileIdList = [];
        for (var i = 0 ; i < this.collectedDocuments.length ; i++) {
          this.selectedFileIdList.push(this.collectedDocuments[i].fileId);
        }
      } else {
        this.selectedFileIdList = [];
      }
      this.chkAllCheckFileList = this.isAllCheckFileList();
    },

    isAllCheckFileList() {
      return (this.collectedDocuments.length == this.selectedFileIdList.length);
    },

    checkTimeKbn(timeKbn, checked) {
      if (checked) {
        for (var i = 0 ; i < this.collectedDocuments.length ; i++) {
          if (this.collectedDocuments[i].timeKbn == timeKbn) {
            if (!this.selectedFileIdList.includes(this.collectedDocuments[i].fileId)) {
              this.selectedFileIdList.push(this.collectedDocuments[i].fileId);
            }
          }
        }
      } else {
        for (var i = 0 ; i < this.collectedDocuments.length ; i++) {
          if (this.collectedDocuments[i].timeKbn == timeKbn) {
            let index = this.selectedFileIdList.indexOf(this.collectedDocuments[i].fileId);
            this.selectedFileIdList.splice(index, 1);
          }
        }
      }
    },
    checkTimeKbnHeader(timeKbn) {
      if (timeKbn == "") {
        return;
      }
      var timeKbnList = this.collectedDocuments;
      timeKbnList = timeKbnList.filter((item) => {
          return (
            item.timeKbn == timeKbn
          );
        });
      var isAllSelect = true;
      for (var i = 0 ; i < timeKbnList.length ; i++) {
        if (timeKbnList[i].fileId != timeKbn) {
          if (!this.selectedFileIdList.includes(timeKbnList[i].fileId)) {
            isAllSelect = false;
          }
        }
      }
      if (isAllSelect) {
        if(!this.selectedFileIdList.includes(timeKbn)) {
          this.selectedFileIdList.push(timeKbn);
        }
      } else {
        if(this.selectedFileIdList.includes(timeKbn)) {
          let index = this.selectedFileIdList.indexOf(timeKbn);
          this.selectedFileIdList.splice(index, 1);
        }
      }
    },
 
    // **********************************************
    // * ファイル追加
    // **********************************************
    handleBtnNewFile() {
      this.errors = [];
      this.setErrors();

      // ファイルダイアログ表示
      this.uploadDialogue(true);
    },

    openFolder(folderKey) {
      this.errors = [];
      this.setErrors();

      this.clearFilter();
      this.clearSort();
      this.selectedFileIdList = [];
      this.chkAllCheckFileList = false;

      this.processDialogue(true);
      
      this.searchKeywordFlag = false;

      // フォルダー開く
      let params = {
        currentFolderKey: folderKey,
        
        displayMode: this.displayMode,
        searchTarget: this.searchTarget,
        searchKeyword: this.searchKeyword,
        inCompleteFilterFlag: this.inCompleteFilterFlag
      }

      //キーワード検索適用
      //this.isSearchKeyEnter = true;
      // 収集書類ヘッダー情報リストを取得する
      API_STFMFM02C02_Initialize(params).then(
        (response) => {
          if (response.result == "0000") {
            //正常時
            this.allData = response.collectDataList;
            this.collectedDocuments = response.collectDataList;
            this.setCollectedDocumentCount();

            if (response.errorCD != null && response.errorCD != "") {
              this.errors.push(
                Common.createError(
                  response.errorCD,
                  Common.getMessage(response.errorCD, ["電子取引"])
                )
              );
            }

          } else {
            // エラー表示
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [])
              )
            );
          }

          // 初期値設定
          if (response.currentPath != null) {
            this.currentPath = response.currentPath;
          }
          if (this.currentPath != null) {
            if (this.currentPath == "") {
              this.currentPathSplit = [];
              this.currentPathSplit.push("電子取引");
            } else {
              this.currentPathSplit = this.currentPath.split("\\");
            }
          }
          if (response.currentFolderKey != null) {
            this.currentFolderKey = response.currentFolderKey;
          }
          if (response.encryptFolderKey != null) {
            this.encryptFolderKey = response.encryptFolderKey;
          }
          if (response.currentFolderKeyList != null) {
            this.currentFolderKeyList = response.currentFolderKeyList;
          }
          if (response.displayMode != null) {
            this.displayMode = response.displayMode;
          }
          if (response.userType != null) {
            this.userType = response.userType;
          }
          if (response.userFolderFileAuthFlag != null) {
            this.userFolderFileAuthFlag = response.userFolderFileAuthFlag;
          }
          if (response.userFileAuthFlag != null) {
            this.userFileAuthFlag = response.userFileAuthFlag;
          }
          if (response.userDownloadAuthFlag != null) {
            this.userDownloadAuthFlag = response.userDownloadAuthFlag;
          }

          // 画面制御
          this.visibleSetting();
          
          this.setErrors();

          this.processDialogue(false);
        }
      );
    },

    openFile(fileKey) {
      this.errors = [];
      this.setErrors();

      this.processDialogue(true);

      //this.ViewFileKeyList = [];     
      let storeList = []
      for (var i = 0 ; i < this.collectedDocuments.length ; i++) {
        if (this.collectedDocuments[i].listType == '0') {
          let objFileKey = JSON.parse(this.collectedDocuments[i].fileKey)
          objFileKey.FileName = ""
          
          let obj = {
            FileId: objFileKey.FileId,
            Version:objFileKey.Version,
            FileName:"",
            FolderKey:objFileKey.FolderKey
          }
          storeList.push(JSON.stringify(obj))
          this.collectedDocuments[i].fileKey = JSON.stringify(objFileKey)
          //this.ViewFileKeyList.push(this.collectedDocuments[i].fileKey);
        }
      }

      var store = JSON.stringify(storeList).toString();
      const encoder = new TextEncoder();
      const encodedData = encoder.encode(store);

      var byteCount = encodedData.length;
      var countSize = byteCount / 1024.0/ 1024.0;

      //または合計サイズが5MBを超える。
      if (countSize / 1024 / 1024 / 5 > 1) {
        this.setErrMsg("MTFM5060", []);
        return true;
      }
      sessionStorage.setItem("ViewFileKeyList",JSON.stringify(storeList))
      let params = {
        SelectFileKey: fileKey,
        //ViewFileKeyList: this.ViewFileKeyList,
        displayMode: this.displayMode,
        searchTarget: this.searchTarget,
        searchKeyword: this.searchKeyword,
        inCompleteFilterFlag: this.inCompleteFilterFlag
      };

      API_STFMFM02C02_OpneFIlePreview(params).then(
        (response) => {
          if (response.result == "0000") {
            //正常時
            
            this.$router.push({
                name: "STFMFM02C09",
                params: {}
              });

          } else {
            // エラー表示
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [])
              )
            );
          }
          this.processDialogue(false);
        }
      );
    },
    btnNewFolder() {
      this.errors = [];
      this.setErrors();

      this.$router.push({
        name: "STFMFM02C05",
        params: {}
      });
    },
    dragFile() {
      //this.uploadDialogue(true);
      this.dropArea.show = true;
      var rect = this.$refs.fileListTable.getBoundingClientRect();
      this.dropArea.top = window.pageYOffset + rect.top + 40;
      this.dropArea.left = window.pageXOffset + rect.left;
      this.dropArea.height = window.innerHeight - rect.top - 40;
      this.dropArea.width = rect.right - rect.left;
      this.$refs.dropAreaDiv.style.top = this.dropArea.top + 'px';
      this.$refs.dropAreaDiv.style.left = this.dropArea.left + 'px';
      this.$refs.dropAreaDiv.style.height = this.dropArea.height + 'px';
      this.$refs.dropAreaDiv.style.width = this.dropArea.width + 'px';
    },
    dropFile(e) {
      this.dropArea.show = false;

      let file = e.dataTransfer.files;
      this.files = file;

      

      if (!this.uploadErrorCheck(e)) {
        return;
      }
      
      // this.uploadCmfDialogue(true);
      this.STFMFM02C16Modle={
        isFileUploadDlgShow: true,
        uploadFiles: this.files,
      };     
    },

    uploadErrorCheck(e) {
      this.errors = [];
      for (var i = 0 ; i < this.files.length ; i++) {
        var file = this.files[i];
        
        // 1.フォルダが選択されている
        if (e != null && e.dataTransfer.items[i].webkitGetAsEntry().isDirectory) {
          this.errors.push(
            Common.createError("MTCL1106", Common.getMessage("MTCL1106")));
          this.setErrors();
          return false;
        }

        // 2.拡張子が.html、.htmのファイルが含まれる。
        if (Common.checkFileSuffix(file.name)) {
          this.errors.push(
            Common.createError("MTCL1107", Common.getMessage("MTCL1107", []))
          );
          this.setErrors();
          return;
        }
        // 拡張子が存在しない場合
        let file_type = file.name.split('.').pop();
        if (file_type == "" || file_type == file.name){
          this.errors.push(
            Common.createError("MTCL1107", Common.getMessage("MTCL1107", []))
          );
          this.setErrors();
          return;
        }

        // 3.0Byteのファイルが存在する。
        if (file.size == 0) {
          this.errors.push(
            Common.createError("MTFM1260", Common.getMessage("MTFM1260"))
          );
          this.setErrors();
          return false;
        }

        // 4.115MBを超えるファイルが存在する。
        if (Common.checkFileSize(file.size)) {
          this.errors.push(
            Common.createError(
              "MTCL1053",
              Common.getMessage("MTCL1053")
            )
          );
          this.setErrors();
          return false;
        }

        // 5.ファイル名に入力禁止文字が使用されている。
        if (!Validation.checkNationalkinsokuchar(file.name)) {
          this.errors.push(
            Common.createError("MTCL1098", Common.getMessage("MTCL1098", [file.name]))
          );
          this.setErrors();
          return false;
        }

        // 6.同一名称のファイルが同一フォルダ内の最新バージョンのファイル存在する。
        var list = Array.from(this.allData);
        list = list.filter((item) => {
          return (
            item.folderPath == this.currentPath &&
            item.fileName == file.name
          );
        });
        if (list.length != 0) {
          this.errors.push(Common.createError(
            "MTFM1170",
            Common.getMessage("MTFM1170")
          ));
          this.setErrors();
          return false;
        }
      }
      this.setErrors();
      return true;
    },
    
    selectedFile(e) {
      let file = e.target.files || e.dataTransfer.files;
      let currentDate = new Date()
      let milliseconds = currentDate.getMilliseconds();

      let timeStamp = moment(currentDate).format("YYYYMMDDHHmmss") + `${milliseconds}`; 

      if(this.isMobile){
        let newFileList = []
        for (var i = 0 ; i < file.length ; i++) {
          let fileItem = file[i];
          let arrTemp = fileItem.name.split(".");
          let extandName = arrTemp[arrTemp.length - 1].toLowerCase();
          let newFileName = timeStamp +"_"+ (i+1) + "." + extandName
          let newFile = new File([fileItem],newFileName)
          newFileList.push(newFile)
        }
        this.files = newFileList
      } else {
        this.files = file
      }

      
      if (!this.uploadErrorCheck()) {
        return;
      }

    
      // No4スキャナ保存対応
      // this.showCheckConfirmDialog = true
      this.STFMFM02C16Modle={
        isFileUploadDlgShow: true,
        uploadFiles: this.files,
      };     

    },
    sortBy(key) {
      // 時系列表示の場合は無効
      if (this.displayMode == "1") {
        return;
      }
      // isAsc 昇順ならtrue,降順ならfalse
      //this.sort.isAsc = this.sort.key === key ? !this.sort.isAsc : true;
      this.sort.isAsc = true;
      this.sort.key = key;

      // 値を退避
      let value = "";
      if (key == "name") {
        value = this.sort.indexName;
      } else if (key == "paperID") {
        value = this.sort.indexPaperID;  // No4:スキャナ保存対応「ファイル一覧_電子取引・スキャナ保存_フォルダ表示」画面で書類IDのsortを追加
      } else if (key == "fileType") {
        value = this.sort.indexFileType;
      } else if (key == "folder") {
        value = this.sort.indexFolder;
      } else if (key == "tradingDate") {
        value = this.sort.indexTradingDate;
      } else if (key == "tradingName") {
        value = this.sort.indexTradingName;
      } else if (key == "amount") {
        value = this.sort.indexAmount;
      } else if (key == "updateName") {
        value = this.sort.indexUpdateName;
      } else if (key == "biko") {
        value = this.sort.indexBiko;
      } else if (key == "updateDate") {
        value = this.sort.indexUpdateDate;
      }

      // 昇順、降順
      if (value == 0) {
        this.sort.isAsc = true;
      } else if (value == 1) {
        this.sort.isAsc = false;
      }

      // 「▲」、「▼」クラスを削除
      this.sort.sortedNameClass = 0;
      // No4:スキャナ保存対応「ファイル一覧_電子取引・スキャナ保存_フォルダ表示」画面で書類IDのsortを追加
      this.sort.sortedPaperIDClass = 0;
      this.sort.sortedFileTypeClass = 0;
      this.sort.sortedFolderClass = 0;
      this.sort.sortedTradingDateClass = 0;
      this.sort.sortedTradingNameClass = 0;
      this.sort.sortedAmountClass = 0;
      this.sort.sortedUpdateNameClass = 0;
      this.sort.sortedBikoClass = 0;
      this.sort.sortedUpdateDateClass = 0;
      // 既定値に戻す
      this.sort.indexName = 2;
      // No4:スキャナ保存対応「ファイル一覧_電子取引・スキャナ保存_フォルダ表示」画面で書類IDのsortを追加
      this.sort.indexPaperID = 2;
      this.sort.indexFileType = 2;
      this.sort.indexFolder = 2;
      this.sort.indexTradingDate = 2;
      this.sort.indexTradingName = 2;
      this.sort.indexAmount = 2;
      this.sort.indexUpdateName = 2;
      this.sort.indexBiko = 2;
      this.sort.indexUpdateDate = 1;

      if (key == "name") {
        this.sort.indexName = (value % 2) + 1;
        this.sort.sortedNameClass = this.sort.indexName;
      } else if (key == "paperID") {  // No4:スキャナ保存対応「ファイル一覧_電子取引・スキャナ保存_フォルダ表示」画面で書類IDのsortを追加 start
        this.sort.indexPaperID = (value % 2) + 1;
        this.sort.sortedPaperIDClass = this.sort.indexPaperID;  // No4:スキャナ保存対応「ファイル一覧_電子取引・スキャナ保存_フォルダ表示」画面で書類IDのsortを追加 end
      } else if (key == "fileType") {
        this.sort.indexFileType = (value % 2) + 1;
        this.sort.sortedFileTypeClass = this.sort.indexFileType;
      } else if (key == "folder") {
        this.sort.indexFolder = (value % 2) + 1;
        this.sort.sortedFolderClass = this.sort.indexFolder;
      } else if (key == "tradingDate") {
        this.sort.indexTradingDate = (value % 2) + 1;
        this.sort.sortedTradingDateClass = this.sort.indexTradingDate;
      } else if (key == "tradingName") {
        this.sort.indexTradingName = (value % 2) + 1;
        this.sort.sortedTradingNameClass = this.sort.indexTradingName;
      } else if (key == "amount") {
        this.sort.indexAmount = (value % 2) + 1;
        this.sort.sortedAmountClass = this.sort.indexAmount;
      } else if (key == "updateName") {
        this.sort.indexUpdateName = (value % 2) + 1;
        this.sort.sortedUpdateNameClass = this.sort.indexUpdateName;
      } else if (key == "biko") {
        this.sort.indexBiko = (value % 2) + 1;
        this.sort.sortedBikoClass = this.sort.indexBiko;
      } else if (key == "updateDate") {
        this.sort.indexUpdateDate = (value % 2) + 1;
        this.sort.sortedUpdateDateClass = this.sort.indexUpdateDate;
      }
      this.sortFileList();
    },
    sortFileList() {
      var fileList = Array.from(this.collectedDocuments);
      // デフォルトの並び替え
      // if (this.searchKeywordFlag && this.displayMode == "0") {
      //   fileList.sort(function(a, b) {
      //       return a.listType < b.listType ? 1 : 
      //         a.folderPath > b.folderPath ? 1 : 
      //         a.folderPath < b.folderPath ? -1 : 
      //         a.fileName > b.fileName ? 1 : -1;
      //     });
      // }
      // ソート実施
      if (this.sort.key != "") {
        // 名称
        if (this.sort.key == "name" && this.sort.indexName != 0) {
          if (this.sort.isAsc) {
            fileList.sort(function(a, b) {
              return a.listType < b.listType ? 1 : a.listType > b.listType ? -1 : a.fileName >= b.fileName ? 1 : -1;
            });
          } else {
            fileList.sort(function(a, b) {
              return a.listType < b.listType ? -1 : a.listType > b.listType ? 1 : a.fileName > b.fileName ? -1 : 1;
            });
          }
        } else if (this.sort.key == "paperID" && this.sort.indexPaperID != 0) {  // No4:スキャナ保存対応「ファイル一覧_電子取引・スキャナ保存_フォルダ表示」画面で書類IDのsortを追加 start
          if (this.sort.isAsc) {
            fileList.sort(function (a, b) {
              return a.listType < b.listType ? 1 : a.listType > b.listType ? -1 : a.paperID - b.paperID >= 0 ? 1 : -1;
            });
          } else {
            fileList.sort(function (a, b) {
              return a.listType < b.listType ? -1 : a.listType > b.listType ? 1 : a.paperID - b.paperID >= 0 ? -1 : 1;
            });
          }  // No4:スキャナ保存対応「ファイル一覧_電子取引・スキャナ保存_フォルダ表示」画面で書類IDのsortを追加 end
        } else if (this.sort.key == "fileType" && this.sort.indexFileType != 0) {
          if (this.sort.isAsc) {
            fileList.sort(function(a, b) {
              return a.listType < b.listType ? 1 : a.listType > b.listType ? -1 : a.fileType >= b.fileType ? 1 : -1;
            });
          } else {
            fileList.sort(function(a, b) {
              return a.listType < b.listType ? -1 : a.listType > b.listType ? 1 : a.fileType > b.fileType ? -1 : 1;
            });
          }
        } else if (this.sort.key == "folder" && this.sort.indexFolder != 0) {
          if (this.sort.isAsc) {
            fileList.sort(function(a, b) {
              return a.listType < b.listType ? 1 : a.listType > b.listType ? -1 : a.folderPath >= b.folderPath ? 1 : -1;
            });
          } else {
            fileList.sort(function(a, b) {
              return a.listType < b.listType ? -1 : a.listType > b.listType ? 1 : a.folderPath > b.folderPath ? -1 : 1;
            });
          }
        } else if (this.sort.key == "tradingDate" && this.sort.indexTradingDate != 0) {
          if (this.sort.isAsc) {
            fileList.sort(function(a, b) {
              return a.listType < b.listType ? 1 : a.listType > b.listType ? -1 : a.tradingDate >= b.tradingDate ? 1 : -1;
            });
          } else {
            fileList.sort(function(a, b) {
              return a.listType < b.listType ? -1 : a.listType > b.listType ? 1 : a.tradingDate > b.tradingDate ? -1 : 1;
            });
          }
        } else if (this.sort.key == "tradingName" && this.sort.indexTradingName != 0) {
          if (this.sort.isAsc) {
            fileList.sort(function(a, b) {
              return a.listType < b.listType ? 1 : a.listType > b.listType ? -1 : a.tradingName >= b.tradingName ? 1 : -1;
            });
          } else {
            fileList.sort(function(a, b) {
              return a.listType < b.listType ? -1 : a.listType > b.listType ? 1 : a.tradingName > b.tradingName ? -1 : 1;
            });
          }
        } else if (this.sort.key == "amount" && this.sort.indexAmount != 0) {
          if (this.sort.isAsc) {
            fileList.sort(function(a, b) {
              return a.listType < b.listType ? 1 : a.listType > b.listType ? -1 : Number(a.tradingAmount) >= Number(b.tradingAmount) ? 1 : -1;
            });
          } else {
            fileList.sort(function(a, b) {
              return a.listType < b.listType ? -1 : a.listType > b.listType ? 1 : Number(a.tradingAmount) > Number(b.tradingAmount) ? -1 : 1;
            });
          }
        } else if (this.sort.key == "updateName" && this.sort.indexUpdateName != 0) {
          if (this.sort.isAsc) {
            fileList.sort(function(a, b) {
              return a.listType < b.listType ? 1 : a.listType > b.listType ? -1 : a.updateName >= b.updateName ? 1 : -1;
            });
          } else {
            fileList.sort(function(a, b) {
              return a.listType < b.listType ? -1 : a.listType > b.listType ? 1 : a.updateName > b.updateName ? -1 : 1;
            });
          }
        } else if (this.sort.key == "biko" && this.sort.indexBiko != 0) {
          if (this.sort.isAsc) {
            fileList.sort(function(a, b) {
              return a.listType < b.listType ? 1 : a.listType > b.listType ? -1 : a.biko >= b.biko ? 1 : -1;
            });
          } else {
            fileList.sort(function(a, b) {
              return a.listType < b.listType ? -1 : a.listType > b.listType ? 1 : a.biko > b.biko ? -1 : 1;
            });
          }
        } else if (this.sort.key == "updateDate" && this.sort.indexUpdateDate != 0) {
          if (this.sort.isAsc) {
            fileList.sort(function(a, b) {
              return a.listType < b.listType ? 1 : a.listType > b.listType ? -1 : a.updateDate > b.updateDate ? 1 : -1;
            });
          } else {
            fileList.sort(function(a, b) {
              return a.listType < b.listType ? -1 : a.listType > b.listType ? 1 : a.updateDate >= b.updateDate ? -1 : 1;
            });
          }
        }
      }
      this.collectedDocuments = fileList;
      this.setCollectedDocumentCount();
    },
    ikkatsuErrorCheck(ikkatsuCd) {
      this.errors = [];
      // 0:一括処理
      // 1:複写
      // 2:移動
      // 3:ダウンロード
      // 4:削除

      // 1.ファイル・フォルダが選択されていない
      if (this.selectedFileIdList.length == 0) {
        this.errors.push(Common.createError(
            "MTFM1010",
            Common.getMessage("MTFM1010")
          ));
        this.setErrors();
        return false;
      }
      
      // // オンライン側でのチェック
      // let params = {
      //   fileIdList: this.selectedFileIdList,
      //   currentPath: this.currentPath,
      //   displayMode: this.displayMode,
      //   searchTarget: this.searchTarget,
      //   searchKeyword: this.searchKeyword,
      // };
      // API_STFMFM02C02_CheckFile(this.selectedFileIdList).then(
      //   (response) => {
      //     if (response.result == "0000") {
      //       //正常時
            
      //     } else {
      //       // エラー表示
      //       this.errors.push(
      //         Common.createError(
      //           response.errorCD,
      //           Common.getMessage(response.errorCD, [])
      //         )
      //       );
      //     }
      //   }
      // );

      return true;
    },
    async serachFileList() {
      this.errors = [];
      this.setErrors();
      
      this.selectedFileIdList = [];
      this.chkAllCheckFileList = false;

      this.processDialogue(true);

      // // 検索時のフラグ設定
      // this.searchKeywordFlag = true;

      this.searchedTarget = this.searchTarget;
      this.searchedKeyword = this.searchKeyword;

      let params = {
        currentFolderKey: this.currentFolderKey,
        displayMode: this.displayMode,
        searchTarget: this.searchTarget,
        searchKeyword: this.searchKeyword,
        inCompleteFilterFlag: this.inCompleteFilterFlag
      };

      // if (this.searchKeywordFlag || this.displayMode == "1") {
      if (this.inCompleteFilterFlag || this.searchKeywordFlag || this.searchFilterFlag || this.displayMode == "1") {
        await API_STFMFM02C02_SearchFileList(params).then(
          (response) => {
            if (response.result == "0000") {
              //正常時
              this.allData = response.collectDataList;
              this.collectedDocuments = response.collectDataList;
              this.setCollectedDocumentCount();
            } else {
              // エラー表示
              this.errors.push(
                Common.createError(
                  response.errorCD,
                  Common.getMessage(response.errorCD, [])
                )
              );
            }
          }
        );
      } else {
        await API_STFMFM02C02_Initialize(params).then(
          (response) => {
            if (response.result == "0000") {
              //正常時
              this.allData = response.collectDataList;
              this.collectedDocuments = response.collectDataList;
              this.setCollectedDocumentCount();
            } else {
              // エラー表示
              this.errors.push(
                Common.createError(
                  response.errorCD,
                  Common.getMessage(response.errorCD, [])
                )
              );
            }
          }
        );
      }
      
      if (this.errors.length != 0) {
        this.setErrors();
        this.processDialogue(false);
        return;
      }

      var filterInfo = Array.from(this.allData);

      // 取引情報登録未完了フィルタ
      if (this.inCompleteFilterFlag) {
        filterInfo = filterInfo.filter((item) => {
          return (
            (this.displayMode == "1" && item.listType == '2') ||
            this.isInComplete(item)
          );
        });
      }

      // キーワード検索
      if (this.searchKeyword != "") {
        filterInfo = filterInfo.filter((item) => {
          return (
            (this.displayMode == "1" && item.listType == '2') ||
            item.fileName.includes(this.searchKeyword) ||
            item.paperID.includes(this.searchKeyword) ||  // No4:スキャナ保存対応 書類ID
            item.fileType.includes(this.searchKeyword) ||
            String(this.formatDate(item.tradingDate)).includes(this.searchKeyword) ||
            item.tradingDate.includes(this.searchKeyword) ||
            item.tradingName.includes(this.searchKeyword) ||
            item.tradingAmount.includes(this.searchKeyword) ||
            (item.biko == "" ? false : item.biko.includes(this.searchKeyword)) ||
            item.updateName.includes(this.searchKeyword) ||
            item.updateDate.includes(this.searchKeyword)
          );
        });
        // this.searchKeywordFlag = true;
      }

      // フィルタ　取引情報登録状況
      if (!this.inCompleteFilterFlag &&
        this.STFMFM02C11FilterInit.dealinginfoInputStatus != DealinginfoInputStatusCodeValue.All) {
        if (this.STFMFM02C11FilterInit.dealinginfoInputStatus == DealinginfoInputStatusCodeValue.Finished) {
          filterInfo = filterInfo.filter((item) => {
            return (
              (this.displayMode == "1" && item.listType == '2') ||
              this.isComplete(item)
            );
          });
        }
      }

      // フィルタ　名称検索
      if (this.STFMFM02C11FilterInit.fileName != FileNameCodeValue.All) {
        if (this.STFMFM02C11FilterInit.fileName == FileNameCodeValue.Include) {
          filterInfo = filterInfo.filter((item) => {
            return (
              (this.displayMode == "1" && item.listType == '2') ||
              item.fileName.includes(this.STFMFM02C11FilterInit.fileNameInput)
            );
          });
        } else if (this.STFMFM02C11FilterInit.fileName == FileNameCodeValue.Exclude) {
          filterInfo = filterInfo.filter((item) => {
            return (
              (this.displayMode == "1" && item.listType == '2') ||
              !item.fileName.includes(this.STFMFM02C11FilterInit.fileNameInput)
            );
          });
        }
      }
      // No4:スキャナ保存対応 書類ID start
      // フィルタ　書類ID
      if (this.STFMFM02C11FilterInit.paperID != PaperIdCodeValue.All) {
        if (this.STFMFM02C11FilterInit.paperID == PaperIdCodeValue.Include) {
          filterInfo = filterInfo.filter((item) => {
            return (
              (this.displayMode == "1" && item.listType == '2') ||
              item.paperID.includes(this.STFMFM02C11FilterInit.paperIdInput)
            );
          });
        } else if (this.STFMFM02C11FilterInit.paperID == PaperIdCodeValue.Exclude) {
          filterInfo = filterInfo.filter((item) => {
            return (
              (this.displayMode == "1" && item.listType == '2') ||
              !item.paperID.includes(this.STFMFM02C11FilterInit.paperIdInput)
            );
          });
        }
      } // No4:スキャナ保存対応 書類ID end
      // フィルタ　書類種別
      if (this.STFMFM02C11FilterInit.paperType != PaperTypeCodeValue.All) {
        if (this.STFMFM02C11FilterInit.paperType == PaperTypeCodeValue.Include) {
          filterInfo = filterInfo.filter((item) => {
            return (
              (this.displayMode == "1" && item.listType == '2') ||
              item.fileType.includes(this.STFMFM02C11FilterInit.paperTypeInput)
            );
          });
        } else if (this.STFMFM02C11FilterInit.paperType == PaperTypeCodeValue.Exclude) {
          filterInfo = filterInfo.filter((item) => {
            return (
              (this.displayMode == "1" && item.listType == '2') ||
              !item.fileType.includes(this.STFMFM02C11FilterInit.paperTypeInput)
            );
          });
        } else if (this.STFMFM02C11FilterInit.paperType == PaperTypeCodeValue.NotEntered) {
          filterInfo = filterInfo.filter((item) => {
            return (
              (this.displayMode == "1" && item.listType == '2') ||
              item.fileType == ""
            );
          });
        } else if (this.STFMFM02C11FilterInit.paperType == PaperTypeCodeValue.Other) {
          filterInfo = filterInfo.filter((item) => {
            return (
              (this.displayMode == "1" && item.listType == '2') ||
              item.fileType != "" &&
              item.fileType != "注文書" &&
              item.fileType != "契約書" &&
              item.fileType != "送り状" &&
              item.fileType != "領収書" &&
              item.fileType != "見積書" &&
              item.fileType != "請求書"
            );
          });
        }else {
          var fileTypeName =
            this.STFMFM02C11FilterInit.paperType == PaperTypeCodeValue.PurchaseOrder ? "注文書" :
            this.STFMFM02C11FilterInit.paperType == PaperTypeCodeValue.Contract ? "契約書" :
            this.STFMFM02C11FilterInit.paperType == PaperTypeCodeValue.Invoice ? "送り状" :
            this.STFMFM02C11FilterInit.paperType == PaperTypeCodeValue.Receipt ? "領収書" :
            this.STFMFM02C11FilterInit.paperType == PaperTypeCodeValue.Quotation ? "見積書" :
            this.STFMFM02C11FilterInit.paperType == PaperTypeCodeValue.Bill ? "請求書" : "";
          filterInfo = filterInfo.filter((item) => {
            return (
              (this.displayMode == "1" && item.listType == '2') ||
              item.fileType == fileTypeName
            );
          });
        }
      }
      // フィルタ　取引年月日
      if (this.STFMFM02C11FilterInit.issueDate != IssueDateCodeValue.All) {
        // SpecifiedDay:"1",			//指定日
        // BeforeSpecifiedDay:"2",		//指定日以前
        // AfterSpecifiedDay:"3",		//指定日以降
        // SpecifiedMonth:"4",			//指定月
        // DuringDate:"5",				//指定期間
        var dateFrom = String(warekiToYear(this.STFMFM02C11FilterInit.issueDateGengoFromInput, this.STFMFM02C11FilterInit.issueDateYearFromInput)).padStart(4,"0") + 
                    this.STFMFM02C11FilterInit.issueDateMonthFromInput.padStart(2, "0") + 
                    this.STFMFM02C11FilterInit.issueDateDayFromInput.padStart(2, "0");
        var dateTo = String(warekiToYear(this.STFMFM02C11FilterInit.issueDateGengoToInput, this.STFMFM02C11FilterInit.issueDateYearToInput)).padStart(4,"0") + 
                    this.STFMFM02C11FilterInit.issueDateMonthToInput.padStart(2, "0") + 
                    this.STFMFM02C11FilterInit.issueDateDayToInput.padStart(2, "0");
        if (this.STFMFM02C11FilterInit.issueDate == IssueDateCodeValue.SpecifiedDay) {
          filterInfo = filterInfo.filter((item) => {
            return (
              (this.displayMode == "1" && item.listType == '2') ||
              Number(this.formatDateYYYMMDD(item.tradingDate)) == Number(dateFrom)
            );
          });
        } else if (this.STFMFM02C11FilterInit.issueDate == IssueDateCodeValue.BeforeSpecifiedDay) {
          filterInfo = filterInfo.filter((item) => {
            return (
              (this.displayMode == "1" && item.listType == '2') ||
              this.formatDateYYYMMDD(item.tradingDate) <= dateFrom
            );
          });
        } else if (this.STFMFM02C11FilterInit.issueDate == IssueDateCodeValue.AfterSpecifiedDay) {
          filterInfo = filterInfo.filter((item) => {
            return (
              (this.displayMode == "1" && item.listType == '2') ||
              this.formatDateYYYMMDD(item.tradingDate) >= dateFrom
            );
          });
        } else if (this.STFMFM02C11FilterInit.issueDate == IssueDateCodeValue.SpecifiedMonth) {
          filterInfo = filterInfo.filter((item) => {
            return (
              (this.displayMode == "1" && item.listType == '2') ||
              this.formatDateYYYMMDD(item.tradingDate).substring(0, 6) == dateFrom.substring(0, 6)
            );
          });
        } else if (this.STFMFM02C11FilterInit.issueDate == IssueDateCodeValue.DuringDate) {
          filterInfo = filterInfo.filter((item) => {
            return (
              (this.displayMode == "1" && item.listType == '2') ||
              this.formatDateYYYMMDD(item.tradingDate) >= dateFrom && 
              this.formatDateYYYMMDD(item.tradingDate) <= dateTo
            );
          });
        }
      }
      // フィルタ　取引先
      if (this.STFMFM02C11FilterInit.company != CompanyCodeValue.All) {
        if (this.STFMFM02C11FilterInit.company == CompanyCodeValue.Include) {
          filterInfo = filterInfo.filter((item) => {
            return (
              (this.displayMode == "1" && item.listType == '2') ||
              item.tradingName.includes(this.STFMFM02C11FilterInit.companyInput)
            );
          });
        } else if (this.STFMFM02C11FilterInit.company == CompanyCodeValue.Exclude) {
          filterInfo = filterInfo.filter((item) => {
            return (
              (this.displayMode == "1" && item.listType == '2') ||
              !item.tradingName.includes(this.STFMFM02C11FilterInit.companyInput)
            );
          });
        } else if (this.STFMFM02C11FilterInit.company == CompanyCodeValue.NotEntered) {
          filterInfo = filterInfo.filter((item) => {
            return (
              (this.displayMode == "1" && item.listType == '2') ||
              item.tradingName == ""
            );
          });
        }
      }
      // フィルタ　取引金額
      var amFrom = this.STFMFM02C11FilterInit.amountFromInput.replace(/,/g, "");
      var amTo = this.STFMFM02C11FilterInit.amountToInput.replace(/,/g, "");
      if (this.STFMFM02C11FilterInit.amount != AmountCodeValue.All) {
        if (this.STFMFM02C11FilterInit.amount == AmountCodeValue.SpecifiedAmount) {
          filterInfo = filterInfo.filter((item) => {
            return (
              (this.displayMode == "1" && item.listType == '2') ||
              (item.tradingAmount == "" ? false : 
                Number(item.tradingAmount) == Number(amFrom))
            );
          });
        } else if (this.STFMFM02C11FilterInit.amount == AmountCodeValue.LessSpecifiedAmount) {
          filterInfo = filterInfo.filter((item) => {
            return (
              (this.displayMode == "1" && item.listType == '2') ||
              (item.tradingAmount == "" ? false : 
                Number(item.tradingAmount) <= Number(amFrom))
            );
          });
        } else if (this.STFMFM02C11FilterInit.amount == AmountCodeValue.MoreSpecifiedAmount) {
          filterInfo = filterInfo.filter((item) => {
            return (
              (this.displayMode == "1" && item.listType == '2') ||
              (item.tradingAmount == "" ? false : 
                Number(item.tradingAmount) >= Number(amFrom))
            );
          });
        } else if (this.STFMFM02C11FilterInit.amount == AmountCodeValue.DuringAmount) {
          filterInfo = filterInfo.filter((item) => {
            return (
              (this.displayMode == "1" && item.listType == '2') ||
              (item.tradingAmount == "" ? false : 
                Number(item.tradingAmount) >= Number(amFrom) &&
                Number(item.tradingAmount) <= Number(amTo))
            );
          });
        }
      }
      // フィルタ　備考
      if (this.STFMFM02C11FilterInit.remarks != RemarksCodeValue.All) {
        if (this.STFMFM02C11FilterInit.remarks == RemarksCodeValue.Include) {
          filterInfo = filterInfo.filter((item) => {
            return (
              (this.displayMode == "1" && item.listType == '2') ||
              item.biko.includes(this.STFMFM02C11FilterInit.remarksInput)
            );
          });
        } else if (this.STFMFM02C11FilterInit.remarks == RemarksCodeValue.Exclude) {
          filterInfo = filterInfo.filter((item) => {
            return (
              (this.displayMode == "1" && item.listType == '2') ||
              !item.biko.includes(this.STFMFM02C11FilterInit.remarksInput)
            );
          });
        } else if (this.STFMFM02C11FilterInit.remarks == RemarksCodeValue.NotEntered) {
          filterInfo = filterInfo.filter((item) => {
            return (
              (this.displayMode == "1" && item.listType == '2') ||
              item.biko == ""
            );
          });
        }
      }
      // フィルタ　改訂者
      if (this.STFMFM02C11FilterInit.updater != UpdaterCodeValue.All) {
        if (this.STFMFM02C11FilterInit.updater == UpdaterCodeValue.Include) {
          filterInfo = filterInfo.filter((item) => {
            return (
              (this.displayMode == "1" && item.listType == '2') ||
              item.updateName.includes(this.STFMFM02C11FilterInit.updaterInput)
            );
          });
        } else if (this.STFMFM02C11FilterInit.updater == UpdaterCodeValue.Exclude) {
          filterInfo = filterInfo.filter((item) => {
            return (
              (this.displayMode == "1" && item.listType == '2') ||
              !item.updateName.includes(this.STFMFM02C11FilterInit.updaterInput)
            );
          });
        }
      }

      // 検索後日付行に属するファイルがヒットしなかった時の不要な日付行の削除
      if (this.displayMode == "1" && filterInfo.length > 0) {
        let timeKbn = filterInfo[filterInfo.length-1].timeKbn;
        let count = 0;
        for (var i = filterInfo.length-1 ; i >= 0 ; i--) {
          if (timeKbn != filterInfo[i].timeKbn) {
            if (count == 1) {
              filterInfo.splice(i+1, 1);
            }
            count = 0;
          }
          timeKbn = filterInfo[i].timeKbn;
          count++;
        }
        if (count == 1) {
          filterInfo.splice(0, 1);
        }
      }

      // 検索時のデフォルトの並び替え
      if (this.searchKeywordFlag && this.displayMode == "0") {
        filterInfo.sort(function(a, b) {
            return a.listType < b.listType ? 1 : 
              a.folderPath > b.folderPath ? 1 : 
              a.folderPath < b.folderPath ? -1 : 
              a.fileName > b.fileName ? 1 : -1;
          });
      }
      
      this.collectedDocuments = filterInfo;
      this.setCollectedDocumentCount();

      // 1000件以上は削除
      let isLimit = false;
      if ((this.searchKeywordFlag || this.displayMode == "1") && this.collectedDocumentCount > 1000) {
        this.collectedDocuments.length = 1000;
        this.collectedDocumentCount = 1000;
        isLimit = true;
      }

      // 画面制御
      this.visibleSetting();
      //this.calculateWindowWidth();

      this.setErrors();

      this.processDialogue(false);

      if (isLimit) {
        this.isShowSearchLimit = true;
      }
      this.isSearchLimit = isLimit;
    },

    // **********************************************
    //  ダウンロードボタンをクリック
    // **********************************************
    execDownload(e) {
      this.errors = [];
      this.setErrors();

      this.processDialogue(true);

      let selectFileKey = "";
      let selectFileKeyList = [];
      let selectFolderKey = "";
      let selectFolderKeyList = [];
      
      if (e == null || e == "") {
        for (var i = 0 ; i < this.collectedDocuments.length ; i++) {
          if (this.selectedFileIdList.includes(this.collectedDocuments[i].fileId)) {
            if (this.collectedDocuments[i].listType == "0") {
              selectFileKeyList.push(this.collectedDocuments[i].fileKey);
            } else if (this.collectedDocuments[i].listType == "1") {
              selectFolderKeyList.push(this.collectedDocuments[i].folderKey);
            }
          }
        }
      } else {
        if (e.listType == "0") {
          selectFileKey = e.fileKey;
        } else if (e.listType == "1") {
          selectFolderKey = e.folderKey;
        }
      }

      let param = {
        SelectFileKey: selectFileKey,
        SelectFileKeyList: selectFileKeyList,
        SelectFolderKey: selectFolderKey,
        SelectFolderKeyList: selectFolderKeyList
      };

      API_STFMFM02C02_Download(param).then(async (response) => {
        this.errors = [];
        //正常の場合
        if (_.eq(response.result, "0000")) {
          const result = await downloadAsOtherNameApi(response, response.exportFileName);
          if (_.eq(result.result, "0000")) {
            // 「処理完了画面」表示
            //this.completeDialogue(true);
            // 画面を非表示にする
            //this.exportDialogue(false);
          } else {
            if (_.eq(result.errorCD, "MTCL0999")) {
              // 各種エラー画面に遷移
              this.$router.push({
                name: "STDSCM04C06",
                params: {
                  demo: Common.getMessage("MTCL0999", []),
                },
              });
            } else {
              //上記以外の場合
              this.errors.push(
                Common.createError(
                  result.errorCD,
                  Common.getMessage(result.errorCD, [])
                )
              );
            }
          }
        } else {
          if (_.eq(response.errorCD, "MTCL0999")) {
            // 各種エラー画面に遷移
            this.$router.push({
              name: "STDSCM04C06",
              params: {
                demo: Common.getMessage("MTCL0999", []),
              },
            });
          } else {
            //上記以外の場合
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [])
              )
            );
          }
        }
        
        this.setErrors();

        this.processDialogue(false);
      });
    },

    // **********************************************
    //  改訂履歴エクスポートボタンをクリック
    // **********************************************
    showHistoryExport() {
      this.isShowHistoryExport = true;
    },

    execHistoryExport() {
      this.isShowHistoryExport = false;

      this.errors = [];
      this.setErrors();
      
      this.processDialogue(true);

      let param = {
      };

      API_STFMFM02C02_Export(param).then(async (response) => {
        this.errors = [];
        //正常の場合
        if (_.eq(response.result, "0000")) {
          const result = await downloadAsOtherNameApi(response, response.exportFileName);
          if (_.eq(result.result, "0000")) {
            // 「処理完了画面」表示
            //this.completeDialogue(true);
            // 画面を非表示にする
            //this.exportDialogue(false);
          } else {
            if (_.eq(result.errorCD, "MTCL0999")) {
              // 各種エラー画面に遷移
              this.$router.push({
                name: "STDSCM04C06",
                params: {
                  demo: Common.getMessage("MTCL0999", []),
                },
              });
            } else {
              //上記以外の場合
              this.errors.push(
                Common.createError(
                  result.errorCD,
                  Common.getMessage(result.errorCD, [])
                )
              );
            }
          }
        } else {
          if (_.eq(response.errorCD, "MTCL0999")) {
            // 各種エラー画面に遷移
            this.$router.push({
              name: "STDSCM04C06",
              params: {
                demo: Common.getMessage("MTCL0999", []),
              },
            });
          } else {
            //上記以外の場合
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [])
              )
            );
          }
        }
        
        this.setErrors();

        this.processDialogue(false);
      });
    },

    // ファイル一覧未完了チェック
    isInComplete(info) {
      let flag = false;
      if (info.listType == "0"
        && (info.tradingName == ""
        || info.tradingDate == ""
        || info.tradingAmount == "")) {
          flag = true;
      }
      return flag;
    },
    // ファイル一覧完了チェック
    isComplete(info) {
      let flag = false;
      if (info.listType == "0"
        && (info.tradingName != ""
        && info.tradingDate != ""
        && info.tradingAmount != "")) {
          flag = true;
      }
      return flag;
    },
    // 絞り込み使用チェック
    isSTFMFM02C11Filter() {
      if (this.STFMFM02C11FilterInit.dealinginfoInputStatus == DealinginfoInputStatusCodeValue.Finished ||
          this.STFMFM02C11FilterInit.fileName != FileNameCodeValue.All ||
          this.STFMFM02C11FilterInit.paperID != PaperIdCodeValue.All ||   // No4:スキャナ保存対応 書類ID
          this.STFMFM02C11FilterInit.paperType != PaperTypeCodeValue.All ||
          this.STFMFM02C11FilterInit.issueDate != IssueDateCodeValue.All ||
          this.STFMFM02C11FilterInit.company != CompanyCodeValue.All ||
          this.STFMFM02C11FilterInit.amount != AmountCodeValue.All ||
          this.STFMFM02C11FilterInit.remarks != RemarksCodeValue.All ||
          this.STFMFM02C11FilterInit.updater != UpdaterCodeValue.All) {
            return true;
      } else {
        return false;
      }
    },

    // 画面制御処理
    visibleSetting() {

      // ユーザの種類が税理士事務所の場合
      if (this.userType == "0") {
        // ユーザのフォルダ・ファイルの操作権限がある場合
        if (this.userFolderFileAuthFlag) {
          // ダウンロード操作権限がある場合
          if (this.userDownloadAuthFlag) {
            this.show.btnLink = false;
            this.show.btnNewFile = true;
            this.show.btnNewFolder = true;
            this.show.btnIkkatsu = true;
            this.show.ikkatsuCopy = true;
            this.show.ikkatsuMove = true;
            this.show.ikkatsuDownload = true;
            this.show.ikkatsuDelete = true;
            this.show.listFolderCopy = true;
            this.show.listFolderMove = true;
            this.show.listFolderDownload = true;
            this.show.listFolderEdit = true;
            this.show.listFolderDelete = true;
            this.show.listFileCopy = true;
            this.show.listFileMove = true;
            this.show.listFileDownload = true;
            this.show.listFileDelete = true;
            this.show.listFileExport = true;
            this.enabled.btnNewFile = true;
            this.enabled.btnNewFolder = true;
            this.show.dropArea = true;

          // ダウンロード操作権限が無い場合
          } else {
            this.show.btnLink = false;
            this.show.btnNewFile = true;
            this.show.btnNewFolder = true;
            this.show.btnIkkatsu = true;
            this.show.ikkatsuCopy = true;
            this.show.ikkatsuMove = true;
            this.show.ikkatsuDownload = false;
            this.show.ikkatsuDelete = true;
            this.show.listFolderCopy = true;
            this.show.listFolderMove = true;
            this.show.listFolderDownload = false;
            this.show.listFolderEdit = true;
            this.show.listFolderDelete = true;
            this.show.listFileCopy = true;
            this.show.listFileMove = true;
            this.show.listFileDownload = false;
            this.show.listFileDelete = true;
            this.show.listFileExport = false;
            this.enabled.btnNewFile = true;
            this.enabled.btnNewFolder = true;
            this.show.dropArea = true;
          }
        
        // ユーザのフォルダ・ファイルの操作権限がない場合
        } else {
          // ファイルの操作権限がある場合
          if (this.userFileAuthFlag) {
            // ダウンロード操作権限がある場合
            if (this.userDownloadAuthFlag) {
              this.show.btnLink = false;
              this.show.btnNewFile = true;
              this.show.btnNewFolder = false;
              this.show.btnIkkatsu = true;
              this.show.ikkatsuCopy = true;
              this.show.ikkatsuMove = true;
              this.show.ikkatsuDownload = true;
              this.show.ikkatsuDelete = true;
              this.show.listFolderCopy = false;
              this.show.listFolderMove = false;
              this.show.listFolderDownload = true;
              this.show.listFolderEdit = false;
              this.show.listFolderDelete = false;
              this.show.listFileCopy = true;
              this.show.listFileMove = true;
              this.show.listFileDownload = true;
              this.show.listFileDelete = true;
              this.show.listFileExport = true;
              this.enabled.btnNewFile = true;
              this.enabled.btnNewFolder = true;
              this.show.dropArea = true;

            // ダウンロード操作権限がない場合
            } else {
              this.show.btnLink = false;
              this.show.btnNewFile = true;
              this.show.btnNewFolder = false;
              this.show.btnIkkatsu = true;
              this.show.ikkatsuCopy = true;
              this.show.ikkatsuMove = true;
              this.show.ikkatsuDownload = false;
              this.show.ikkatsuDelete = true;
              this.show.listFolderCopy = false;
              this.show.listFolderMove = false;
              this.show.listFolderDownload = false;
              this.show.listFolderEdit = false;
              this.show.listFolderDelete = false;
              this.show.listFileCopy = true;
              this.show.listFileMove = true;
              this.show.listFileDownload = false;
              this.show.listFileDelete = true;
              this.show.listFileExport = false;
              this.enabled.btnNewFile = true;
              this.enabled.btnNewFolder = true;
              this.show.dropArea = true;
            }
          // ファイルの操作権限がない場合
          } else {
            // ダウンロード操作権限がある場合
            if (this.userDownloadAuthFlag) {
              this.show.btnLink = false;
              this.show.btnNewFile = false;
              this.show.btnNewFolder = false;
              this.show.btnIkkatsu = true;
              this.show.ikkatsuCopy = false;
              this.show.ikkatsuMove = false;
              this.show.ikkatsuDownload = true;
              this.show.ikkatsuDelete = false;
              this.show.listFolderCopy = false;
              this.show.listFolderMove = false;
              this.show.listFolderDownload = true;
              this.show.listFolderEdit = false;
              this.show.listFolderDelete = false;
              this.show.listFileCopy = false;
              this.show.listFileMove = false;
              this.show.listFileDownload = true;
              this.show.listFileDelete = false;
              this.show.listFileExport = true;
              this.enabled.btnNewFile = true;
              this.enabled.btnNewFolder = true;
              this.show.dropArea = false;

            // ダウンロード操作権限がない場合
            } else {
              this.show.btnLink = false;
              this.show.btnNewFile = false;
              this.show.btnNewFolder = false;
              this.show.btnIkkatsu = false;
              this.show.ikkatsuCopy = false;
              this.show.ikkatsuMove = false;
              this.show.ikkatsuDownload = false;
              this.show.ikkatsuDelete = false;
              this.show.listFolderCopy = false;
              this.show.listFolderMove = false;
              this.show.listFolderDownload = false;
              this.show.listFolderEdit = false;
              this.show.listFolderDelete = false;
              this.show.listFileCopy = false;
              this.show.listFileMove = false;
              this.show.listFileDownload = false;
              this.show.listFileDelete = false;
              this.show.listFileExport = false;
              this.enabled.btnNewFile = true;
              this.enabled.btnNewFolder = true;
              this.show.dropArea = false;
            }
          }
        }

      // ユーザの種類が事業所の場合
      } else {
        this.show.btnLink = true;
        this.show.btnNewFile = true;
        this.show.btnNewFolder = true;
        this.show.btnExport = false;
        this.show.btnIkkatsu = true;
        this.show.ikkatsuCopy = true;
        this.show.ikkatsuMove = true;
        this.show.ikkatsuDownload = true;
        this.show.ikkatsuDelete = true;
        this.show.listFolderCopy = true;
        this.show.listFolderMove = true;
        this.show.listFolderDownload = true;
        this.show.listFolderEdit = true;
        this.show.listFolderDelete = true;
        this.show.listFileCopy = true;
        this.show.listFileMove = true;
        this.show.listFileDownload = true;
        this.show.listFileDelete = true;
        this.show.listFileExport = true;
        this.enabled.btnNewFile = true;
        this.enabled.btnNewFolder = true;
        this.show.dropArea = true;
      }

      // フォルダ表示
      if (this.displayMode == "0") {
        if (this.userType == "0") {
          this.show.btnExport = true;
        }
        this.show.searchTarget = true;
        // 検索していない場合
        if (!this.searchKeywordFlag) {
          this.show.currentPath = true;
          this.show.btnLink = !this.show.btnLink ? false : true;
          this.show.btnNewFile = !this.show.btnNewFile ? false : true;
          this.show.btnNewFolder = !this.show.btnNewFolder ? false : true;
          this.show.listFileOpenFolder = false;
          this.enabled.btnNewFile = true;
          this.enabled.btnNewFolder = true;
          this.show.dropArea = !this.show.dropArea ? false : true;

        // 検索している場合
        } else {
          // すべてのフォルダ
          if (this.searchTarget == "0") {
            this.show.currentPath = true;
            this.show.btnLink = false;
            this.show.btnNewFile = !this.show.btnNewFile ? false : true;
            this.show.btnNewFolder = !this.show.btnNewFolder ? false : true;
            this.show.listFileOpenFolder = true;
            this.enabled.btnNewFile = false;
            this.enabled.btnNewFolder = false;
            this.show.dropArea = false;
          
          // すべてのフォルダ以外
          } else {
            this.show.currentPath = true;
            this.show.btnLink = !this.show.btnLink ? false : true;
            this.show.btnNewFile = !this.show.btnNewFile ? false : true;
            this.show.btnNewFolder = !this.show.btnNewFolder ? false : true;
            this.show.listFileOpenFolder = true;
            this.enabled.btnNewFile = false;
            this.enabled.btnNewFolder = false;
            this.show.dropArea = false;
          }
        }

      // 時系列表示
      } else if (this.displayMode == "1") {
        if (this.userType == "0") {
          this.show.btnExport = false;
        }
        this.show.searchTarget = false;

        // 検索していない場合
        if (!this.searchKeywordFlag) {
          this.show.currentPath = false;
          this.show.btnLink = false;
          this.show.btnNewFile = !this.show.btnNewFile ? false : true;
          this.show.btnNewFolder = false;
          this.show.listFileOpenFolder = false;
          this.enabled.btnNewFile = true;
          this.enabled.btnNewFolder = false;
          this.show.dropArea = !this.show.dropArea ? false : true;

        // 検索している場合
        } else {
          this.show.currentPath = false;
          this.show.btnLink = false;
          this.show.btnNewFile = !this.show.btnNewFile ? false : true;
          this.show.btnNewFolder = false;
          this.show.listFileOpenFolder = false;
          this.enabled.btnNewFile = false;
          this.enabled.btnNewFolder = false;
          this.show.dropArea = false;
        }
      }


      // フォルダ列の制御
      if (this.searchKeywordFlag || this.searchFilterFlag || this.displayMode == "1") {
        this.show.fileListFolder = true;
      } else {
        this.show.fileListFolder = false;
      }
    },

    // 一覧カウント
    setCollectedDocumentCount() {
      var countList = this.collectedDocuments;
      countList = countList.filter((item) => {
          return (
            item.listType == '0' ||
            item.listType == '1'
          );
        });
      this.collectedDocumentCount = countList.length;
      
      var countAllList = this.allData;
      countAllList = countAllList.filter((item) => {
          return (
            item.listType == '0' ||
            item.listType == '1'
          );
        });
      this.collectedDocumentAllCount = countAllList.length;

      this.noDataPrompt = this.collectedDocuments.length == 0 ? true : false;
    },

    // 親画面にエラーを設定
    setErrors() {
      this.$emit("getErrors", this.errors);
    },

    // ファイル一覧再取得
    refreshFileList() {
      this.serachFileList();
    },

    // 画面リサイズ
    calculateWindowWidth() {
      // カレントパス
      if (this.show.currentPath) {
        // this.windowWidth = window.innerWidth;
        var allEls = this.$refs.currentPathDiv.querySelectorAll('span[name="currentPathSpanName"]');
        var count = 80;
        //var clientWidth = this.$refs.currentPathDiv.clientWidth;
        var clientWidth = 1000;
        var maxWidth = 800;
        if (this.searchKeywordFlag) {
          clientWidth = 950;
          maxWidth = 700;
        }
        this.currentPathMaxFlag = false;
        var topItem = null;
        for (var i = allEls.length - 1 ; i >= 0 ; i --) {
          allEls[i].style = "";
          for (var j = 0 ; j < allEls[i].children.length ; j ++) {
            var r = allEls[i].children.item(j).getBoundingClientRect();
            if (i == (allEls.length - 1) && r.width > maxWidth) {
              allEls[i].children.item(j).style.width = maxWidth + 'px';
              r = allEls[i].children.item(j).getBoundingClientRect();
            } else if (i <= (allEls.length) && (r.width + count) > clientWidth) {
              allEls[i].children.item(j).style.width = (clientWidth - count) + 'px';
              r = allEls[i].children.item(j).getBoundingClientRect();
            }
            count = count + r.width;
          }
          if (count > clientWidth) {
            this.currentPathMaxFlag = true;
            allEls[i].style = "display: none;";
          } else {
            allEls[i].style = "";
            topItem = allEls[i];
          }
        }
        if (topItem != null) {
          if (this.currentPathMaxFlag) {
            topItem.children.item(0).style = "display: none;";
            if (this.$refs.currentPathRyaku != null) {
              this.$refs.currentPathRyaku.style = "";
            }
          } else {
            if (this.$refs.currentPathRyaku != null) {
              this.$refs.currentPathRyaku.style = "display: none;";
            }
          }
        }
      }
    },

    // **********************************************
    // * 初期フォーカス設定
    // **********************************************
    initFocus() {
     this.$refs.refBtnNewFile.focus();
    },

    mouseOverAction(e) {
      var $current = $(e.target);
      var $target = $($current.next('[data-role="select-menu"]'));
      // ウィンドウ高さを２分割して上下判定
      var position_class = (($(window).height() / 2) > ($current.offset().top - $(window).scrollTop())) ? 'top' : 'bottom';

      $target.removeClass('top bottom').addClass(position_class);
    },
    handleActionButtonClick(e,info) {
      let offsetTop = e.currentTarget.getBoundingClientRect().top
      let offsetLeft = e.currentTarget.getBoundingClientRect().left
      let halfWindowHeight = document.documentElement.clientHeight / 2
      let dropMeauMinWidth = 160
      if(offsetTop > halfWindowHeight){
        this.dropMeauPositon.top = offsetTop -  180  + "px"

      } else {

        this.dropMeauPositon.top = offsetTop +  40  + "px"
      }
     
      this.dropMeauPositon.left = offsetLeft - dropMeauMinWidth + "px"
      this.currentInfo = info;
      this.showMask = true
    },
    handleBatchActionButtonClick(e,info){
      let offsetTop = e.currentTarget.getBoundingClientRect().top
      let offsetLeft = e.currentTarget.getBoundingClientRect().left
      this.dropMeauPositon.top = offsetTop +  35  + "px"
      this.dropMeauPositon.left = offsetLeft + "px"
      this.showBatchMenuMask = true
    },
    
    saveFilter() {
      this.errors = [];
      var paraFilter = _.cloneDeep(this.STFMFM02C11FilterInit);
      paraFilter.amountFromInput = paraFilter.amountFromInput == null ? null : paraFilter.amountFromInput.replace(/,/g, "");
      paraFilter.amountToInput = paraFilter.amountToInput == null ? null : paraFilter.amountToInput.replace(/,/g, "");
      
      let params = {
        sTFMFM02C02Filter: paraFilter,
      };
      // フィルター条件保存処理
      API_STFMFM02C02_SetFilter(params).then((response) => {
        // 正常終了の場合
        if (response.result != "0000") {
          // エラー表示
          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, [])
            )
          );
        }
      });
    },
    handleRemarksModal(text){
      this.remarksModal = {show:true,text} 
    },
    closeMask(key){
      this[key] = false
      this.currentInfo = {};
    }
  },
  created() {
    let dateTime = [];
    const time = moment().format("YYYY/MM/DD"); 
  },
  mounted() {
    var selection = getSelection() 
    selection.empty();
    
    this.$nextTick(function () {
      this.initFocus();
    });

    this.processDialogue(true);

    // window.addEventListener('resize', this.calculateWindowWidth);
    // 遷移元から取得
    this.uploadDialogue(false);
    this.uploadCmfDialogue(false);

    let params = {
        currentKey: this.$route.query.cp,
    }

    //キーワード検索適用
    //this.isSearchKeyEnter = true;
    // 収集書類ヘッダー情報リストを取得する
    API_STFMFM02C02_Initialize(params).then(
      (response) => {
        if (response.result == "0000") {
          if(response.filterInfo != null && response.filterInfo.result == "0000"){
            this.STFMFM02C11FilterInit = response.filterInfo;
            this.searchKeyword = this.STFMFM02C11FilterInit.keyWord;
            this.inCompleteFilterFlag = this.STFMFM02C11FilterInit.dealinginfoInputStatus == DealinginfoInputStatusCodeValue.Unfinished;
            this.searchTarget = this.STFMFM02C11FilterInit.searchTaget;
          }
          else{
            this.STFMFM02C11FilterInit = this.$refs.refSTFMFM02C11FilterCompleteModal.$data.searchConditionInfo;
            this.saveFilter();
          }
          //正常時
          this.allData = response.collectDataList;
          this.collectedDocuments = response.collectDataList;
          this.setCollectedDocumentCount();

          if (response.errorCD != null && response.errorCD != "") {
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, ["電子取引"])
              )
            );
          }

        } else {
          // エラー表示
          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, [])
            )
          );
        }

        // 初期値設定
        if (response.currentPath != null) {
          this.currentPath = response.currentPath;
        }
        if (this.currentPath != null) {
          if (this.currentPath == "") {
            this.currentPathSplit = [];
            this.currentPathSplit.push("電子取引");
          } else {
            this.currentPathSplit = this.currentPath.split("\\");
          }
        }
        if (response.currentFolderKey != null) {
          this.currentFolderKey = response.currentFolderKey;
        }
        if (response.encryptFolderKey != null) {
          this.encryptFolderKey = response.encryptFolderKey;
        }
        if (response.currentFolderKeyList != null) {
          this.currentFolderKeyList = response.currentFolderKeyList;
        }
        if (response.displayMode != null) {
          this.displayMode = response.displayMode;
        }
        if (response.searchTarget != null) {
          this.searchTarget = response.searchTarget;
        }
        if (response.searchKeyword != null) {
          this.searchKeyword = response.searchKeyword;
        }
        if (response.inCompleteFilterFlag != null) {
          this.inCompleteFilterFlag = response.inCompleteFilterFlag;
        }
        if (response.userType != null) {
          this.userType = response.userType;
        }
        if (response.userFolderFileAuthFlag != null) {
          this.userFolderFileAuthFlag = response.userFolderFileAuthFlag;
        }
        if (response.userFileAuthFlag != null) {
          this.userFileAuthFlag = response.userFileAuthFlag;
        }
        if (response.userDownloadAuthFlag != null) {
          this.userDownloadAuthFlag = response.userDownloadAuthFlag;
        }

        // 画面制御
        this.visibleSetting();

        this.setErrors();

        this.processDialogue(false);

        if (this.inCompleteFilterFlag) {
          this.STFMFM02C11FilterInit.dealinginfoInputStatus = DealinginfoInputStatusCodeValue.Unfinished;
        }

        if (this.searchKeyword != "") {
          this.searchKeywordFlag = true;
        }
        if (this.isSTFMFM02C11Filter()) {
          this.searchFilterFlag = true;
        }

        if (this.displayMode == "1" || this.searchKeywordFlag || this.searchFilterFlag || this.inCompleteFilterFlag) {
          this.serachFileList();
        }
      }
    );


  },
  beforeUnmount() {
  //  window.removeEventListener('resize', this.calculateWindowWidth);
  },
  updated() {
    // 画面描画
    this.calculateWindowWidth();
  }
};
</script>

<style scoped>
.current-path-align {
  vertical-align: middle;
}
.current-path-text {
  vertical-align: middle;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.frm-folder-toggle:focus-within {
  outline: 2px ridge;
  outline-color: rgba(26, 74, 146, 0.6);
  border-radius: 8px;
}
.height-38{
  height: 38px;
}

.frm-label-wrap{
  display: flex;
  align-items: center;
}
.frm-label-wrap>.frm-label{
  margin-left: 0;
  min-width: 2em;
}
.frm-row>.frm-item.right, .frm-row>.frm-item.left{
  column-gap:10px;
}
.auto-col{
  width: auto;
  min-width: 185px;
}

.frm-search .frm-search-text {
  width: 100%;
  padding: 4px 10px;
  min-width: 0;
  min-height: 33px;
}
.frm-search form{
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}


@media (max-width: 768px) {
  .body>.inner{
    padding-left:20px;
    padding-right:20px;
  }
  .folder-control-wrap .frm-search{
    width:calc(100vw - 60px);
    margin-left: 0;
  }
  .frm-row>.frm-item.right {
    justify-content:flex-start;
  }
  .frm-item>.frm-btn-control:nth-of-type(1){
    /* margin-left: 0; */
  }
  .table-section{
    width:100%;
    max-width:100%;
  }
  .table-wrap{
    width: 100%;
    overflow-x: auto;
    overflow-y:hidden ;
    padding-bottom: 40px;
  }
  .frm-row{
    height: unset;
  }
  .auto-col{
    width:185px;
  }

  .popup-status{
    word-break: break-all;
  }
  .folder-path-wrap{
    height: unset;
  }
  .current-path-text{
    max-width: calc(100vw - 120px);
  }
  .frm-btn-linkcopy{
    min-width:44px;
  }
  .align-left-p{
    text-align:left;
    margin-bottom: 10px;
  }
  .frm-item.grow.right{
    margin-left: 0;
  }
}


</style>
